export const vi = {
  translation: {
    // WebChat
    chat_with_provider: 'Trò chuyện với bác sĩ',
    // Main Menu
    menu_messages: 'Tin nhắn',
    menu_household: 'Hộ gia đình',
    menu_my_profile: 'Hồ sơ y tế',
    menu_settings: 'Cài đặt',
    menu_log_out: 'Đăng xuất',

    // Register Section
    register_title2: 'Bắt đầu thôi',
    register_subtitle2:
      'Chúng tôi thu thập tên và ngày sinh của bạn để xác minh danh tính và đảm bảo an toàn thông tin cá nhân.',
    register_agree: 'Bằng cách đăng ký, tôi chấp nhận',
    register_terms: 'Điều khoản sử dụng',
    register_privacy: 'Chính sách quyền riêng tư',
    register_and: 'và thừa nhận',
    register_newsletter: 'Tôi muốn nhận bản tin TapTelehealth.',
    register_continue_button: 'Tiếp tục',
    register_have_already: 'Đã có tài khoản?',
    continue_with_google: 'Tiếp tục với Google',
    or: 'HOẶC',

    // Login Section
    log_in_account_question: 'Chưa có tài khoản?',
    log_in_sign_up: 'Đăng ký',

    // Home Dashboard
    welcome:
      'Chào mừng đến Tap Telehealth! Dưới đây là một số bước tiếp theo để chúng tôi chăm sóc bạn và hộ gia đình tốt hơn.',
    hello: 'Xin chào',
    need_med_care_title: 'Cần chăm sóc y tế?',
    need_med_care_text:
      'Nhắn tin ngay cho một trong các bác sĩ của chúng tôi cho mọi nhu cầu chăm sóc sức khỏe không khẩn cấp.',
    text_doctor_button: 'Nhắn tin cho bác sĩ ngay',
    complete_profile_title: 'Hoàn thiện Hồ sơ Y tế của bạn',
    complete_profile_description:
      'Thiết lập hồ sơ y tế để việc chăm sóc sau này suôn sẻ, nhanh chóng và cá nhân hóa hơn khi bạn nhắn tin cho chúng tôi.',
    start_button: 'Bắt đầu',

    // Quick Access
    quick_access_title: 'Truy cập nhanh',
    quick_access_1_title: 'Quản lý hộ gia đình của bạn',
    quick_access_1_text:
      'Dễ dàng thêm thành viên gia đình và hoàn thiện hồ sơ y tế của họ để sẵn sàng nhận chăm sóc khi cần.',
    quick_access_1_cta: 'Quản lý hộ gia đình',

    quick_access_2_title: 'Xem lại',
    quick_access_2_text:
      'Dễ dàng truy cập các phiên trước, đơn thuốc, giấy giới thiệu, giấy xin phép và hơn thế nữa ở một nơi.',
    quick_access_2_cta: 'Xem lịch sử',

    quick_access_3_title: 'Tìm hiểu thêm',
    quick_access_3_text:
      'Tìm hiểu thêm về TapTelehealth và nhiều cách chúng tôi có thể hỗ trợ hành trình sức khỏe của bạn.',
    quick_access_3_cta: 'Tìm hiểu thêm về Tap Telehealth',

    // Household
    household_title: 'Hộ gia đình',
    household_add_pharmacy_banner_title: 'Thêm nhà thuốc ưa thích',
    household_add_pharmacy_banner_description:
      'Chia sẻ thông tin nhà thuốc ưa thích để chúng tôi gửi đơn thuốc đến địa điểm thuận tiện nhất cho bạn.',
    household_add_pharmacy_banner_cta: 'BẮT ĐẦU',
    household_s_member: 'thành viên hộ gia đình',
    household_members: 'Thành viên hộ gia đình',
    household_add: 'Thêm',
    household_member: 'Trẻ vị thành niên',
    household_preferred_pharmacies_title: 'Nhà thuốc ưa thích',
    household_owner: 'Chủ hộ',
    self: 'Bản thân',
    address_not_available: 'Không có địa chỉ',
    before_change_address_title: 'Trước khi bạn thay đổi địa chỉ',
    before_change_address_body:
      'Cập nhật địa chỉ sẽ áp dụng cho tất cả thành viên trong hộ gia đình của bạn. Nếu bạn chỉ muốn thay đổi địa chỉ cho riêng mình, bạn cần rời khỏi hộ gia đình này trước.',
    leave_this_household: 'Rời hộ gia đình này',
    change_address_for_everyone: 'Thay đổi địa chỉ cho mọi người',
    change_your_address_title: 'Thay đổi địa chỉ của bạn',
    household_add_member_rights_notice:
      'Bằng việc thêm một trẻ em vào hộ gia đình, bạn xác nhận rằng bạn có quyền hợp pháp để quản lý thông tin y tế và cá nhân của họ, bao gồm với tư cách là cha mẹ, người giám hộ hợp pháp hoặc đại diện được ủy quyền.',
    household_added_to_your_household: '{{name}} đã được thêm vào hộ gia đình của bạn!',
    household_add_another_member: 'Thêm thành viên hộ gia đình khác',

    // Settings
    settings_title: 'Cài đặt',
    settings_smenu_login_security: 'Đăng nhập & Bảo mật',
    settings_smenu_household: 'Quản lý Hộ gia đình',
    settings_smenu_billing: 'Thanh toán',
    settings_smenu_notifications_privacy: 'Thông báo & Quyền riêng tư',
    settings_email_preferences_card_title: 'Tùy chọn email',
    settings_email_preferences_card_subtitle: 'Cập nhật & Ưu đãi',
    settings_email_preferences_card_description:
      'Nhận cập nhật về dịch vụ của chúng tôi, ưu đãi đặc biệt và mẹo sức khỏe.',
    settings_sms_preferences_card_title: 'Tin nhắn SMS',
    settings_sms_preferences_card_subtitle: 'Thông tin sức khỏe chung và cập nhật liên quan đến dịch vụ',
    settings_sms_preferences_card_description:
      'Bật tính năng này nếu bạn muốn nhận tin nhắn văn bản từ Tap TeleHealth về nhắc nhở sức khỏe cộng đồng, cập nhật dịch vụ và nội dung giáo dục. Có thể áp dụng phí tin nhắn và dữ liệu. Bạn có thể thay đổi tùy chọn bất cứ lúc nào. Những tin nhắn này là tùy chọn và không bắt buộc để sử dụng Dịch vụ Tap Telehealth.',
    settings_privacy_card_title: 'Quyền riêng tư',
    settings_privacy_card_subtitle: 'Thỏa thuận quyền riêng tư (HIPAA)',
    settings_privacy_card_description:
      'Tôi hiểu rằng Tap Telehealth có thể chưa tuân thủ đầy đủ HIPAA. Khi sử dụng dịch vụ này, tôi chấp nhận các rủi ro liên quan và đồng ý việc sử dụng thông tin sức khỏe của tôi khi cần cho dịch vụ khám từ xa.',
    settings_privacy_card_subtitle2: 'Điều khoản sử dụng',
    settings_privacy_card_description2:
      'Tìm hiểu các điều khoản điều chỉnh việc bạn sử dụng nền tảng và dịch vụ của chúng tôi để đảm bảo tuân thủ và minh bạch.',
    settings_privacy_card_terms_link: 'Đọc Điều khoản sử dụng',
    settings_privacy_card_subtitle3: 'Chính sách quyền riêng tư',
    settings_privacy_card_description3:
      'Tìm hiểu cách chúng tôi thu thập, sử dụng và bảo vệ thông tin cá nhân của bạn, cũng như các quyền riêng tư của bạn.',
    settings_privacy_card_policy_link: 'Đọc Chính sách quyền riêng tư',

    settings_billing_card_title: 'Thanh toán',
    settings_billing_card_subtitle:
      'Dịch vụ TapTelehealth của bạn được tính phí thuận tiện qua nhà cung cấp tiện ích, giúp bạn dễ dàng duy trì kết nối với dịch vụ chăm sóc sức khỏe chất lượng.',
    settings_billing_card_subtitle2:
      'Nếu bạn không còn quan tâm sử dụng dịch vụ này, hãy tìm hiểu cách hủy bằng cách nhấp vào liên kết bên dưới.',
    settings_billing_card_cta: 'Tìm hiểu thêm',

    settings_account_deletion_card_title: 'Xóa tài khoản',
    settings_account_deletion_card_description:
      'Khi xóa tài khoản, tất cả hồ sơ y tế, thông tin các phiên trước, hồ sơ trẻ vị thành niên và dữ liệu liên quan sẽ bị xóa vĩnh viễn. Hành động này không thể hoàn tác.',
    settings_account_deletion_card_subtitle: 'Tài khoản',
    settings_account_deletion_card_cta: 'Xóa',

    // Footer
    footer_contact: 'LIÊN HỆ',
    footer_how_it_works: 'Cách Hoạt Động',
    footer_what_we_treat: 'Những Gì Chúng Tôi Điều Trị',
    footer_about: 'Giới thiệu',
    footer_blog: 'Blog',
    footer_partner: 'Hợp tác với chúng tôi',
    // Miscellaneous
    back: 'Quay lại',
    edit: 'Chỉnh sửa',
    cancel: 'Hủy',
    update: 'Cập nhật',
    confirm: 'Xác nhận',
    save: 'Lưu',
    delete: 'Xóa',
    done: 'Hoàn tất',
    next: 'Tiếp theo',
    continue: 'Tiếp tục',
    skip_for_now: 'Bỏ qua lúc này',
    search: 'Tìm kiếm',
    add: 'Thêm',
    added: 'Đã thêm',
    miles: 'dặm',
    yes_remove: 'Có, xóa',
    yes_add: 'Có, thêm {{item}}',
    loading: 'Đang tải',
    yes: 'Có',
    no: 'Không',
    na: 'N/A',
    unknown: 'Không rõ',
    are_you_sure: 'Bạn có chắc không?',
    remove_household_member_confirm: 'Bạn có muốn xóa thành viên hộ gia đình này không?',
    remove_pharmacy_confirm:
      'Bạn có chắc muốn xóa nhà thuốc này khỏi danh sách nhà thuốc ưa thích của hộ gia đình không?',
    please_enter_first_name: 'Vui lòng nhập tên',
    please_enter_middle_name: 'Vui lòng nhập tên đệm (nếu có)',
    please_enter_last_name: 'Vui lòng nhập họ',
    must_be_younger_18: 'Phải dưới 18 tuổi',
    must_be_18_or_older: 'Bạn phải từ 18 tuổi trở lên',

    // Menu additions
    menu_home: 'Trang chủ',
    drawer_menu_title: 'Menu',
    menu_open: 'Mở menu',

    // Alts and misc
    alt_logo: 'Logo',
    alt_profile_icon: 'Biểu tượng hồ sơ',
    time_8_min: '8 phút',

    // Shared links
    terms_of_use: 'Điều khoản sử dụng',
    privacy_policy: 'Chính sách quyền riêng tư',
    and: 'và',
    sign_up: 'Đăng ký',

    // Demographics Module
    demographics_setup_title: 'Hãy bắt đầu thiết lập!',
    demographics_first_name: 'Tên',
    demographics_middle_name: 'Tên đệm',
    demographics_last_name: 'Họ',
    demographics_full_name: 'Họ và tên',
    demographics_email: 'Địa chỉ email',
    demographics_dob: 'Ngày sinh',
    demographics_dob_placeholder: 'MM/DD/YYYY',
    demographics_gender: 'Giới tính',
    demographics_gender_male: 'Nam',
    demographics_gender_female: 'Nữ',
    demographics_gender_other: 'Khác',
    demographics_gender_unknown: 'Không rõ',
    demographics_street_address: 'Địa chỉ đường',
    demographics_address_line_2: 'Địa chỉ dòng 2 (tùy chọn)',
    demographics_city: 'Thành phố',
    demographics_zip_code: 'Mã bưu chính',
    demographics_state: 'Tiểu bang',
    demographics_current_state: 'Tiểu bang bạn đang ở',
    demographics_address: 'Địa chỉ',
    demographics_use_current_location: 'Sử dụng vị trí hiện tại của tôi',
    demographics_continue: 'Tiếp tục',
    demographics_error_current_location: 'Không thể lấy vị trí hiện tại của bạn',
    demographics_add_address_manually: 'Nhập thủ công',

    demographics_consent_title: 'Chỉ cần kiểm tra đồng ý nhanh',
    demographics_consent_body_line1:
      'Tin nhắn, cũng như cuộc gọi và thư thoại, có thể không luôn 100% an toàn tùy theo dịch vụ di động của bạn. Bạn có thể xem <a>Thực hành quyền riêng tư về nhắn tin</a> của chúng tôi để biết thêm chi tiết.',
    demographics_consent_body_line2:
      'Hôm nay, việc chăm sóc sẽ được thực hiện qua khám từ xa (tin nhắn, điện thoại hoặc video) thay vì trực tiếp. Chúng tôi đã giải thích rủi ro, lợi ích và các lựa chọn thay thế — bao gồm quyền dừng lại bất cứ lúc nào và tìm kiếm chăm sóc trực tiếp. Quyền riêng tư của bạn được pháp luật bảo vệ, mặc dù không có hệ thống nào hoàn toàn an toàn.',
    demographics_consent_body_line3:
      'Bạn có đồng ý liên lạc qua tin nhắn và nhận chăm sóc qua khám từ xa hôm nay không?',
    demographics_consent_agree: 'Tôi đồng ý',
    demographics_consent_disagree: 'Tôi không đồng ý',
    demographics_consent_footer_prefix: 'Bạn có thể đọc',
    demographics_consent_footer_suffix: 'để biết thêm chi tiết.',

    demographics_confirm_title: 'Xác nhận thông tin cá nhân của bạn',

    // Demographics - Minor
    demographics_minor_title: 'Thông tin trẻ vị thành niên',
    demographics_minor_address_notice:
      'Chúng tôi chỉ có thể đăng ký trẻ vị thành niên tại cùng địa chỉ nơi cha mẹ hoặc người giám hộ hợp pháp của trẻ hiện đang sinh sống.',
    demographics_minor_success_body: 'Bây giờ bạn có thể quay lại trò chuyện với bác sĩ Tap Telehealth.',

    demographics_no_consent_title: 'Không sao!',
    demographics_no_consent_body_line1:
      'Cảm ơn bạn đã cho chúng tôi biết. Nếu bạn không muốn giao tiếp qua tin nhắn, bạn vẫn có thể nhận chăm sóc hôm nay thông qua Cổng Bệnh Nhân tuân thủ HIPAA của chúng tôi.',
    demographics_no_consent_body_line2: 'Việc chăm sóc vẫn sẽ được thực hiện qua khám từ xa thay vì trực tiếp.',
    demographics_no_consent_body_line3:
      'Bạn có đồng ý nhận chăm sóc qua khám từ xa hôm nay thông qua Cổng Bệnh Nhân không?',
    demographics_no_consent_agree_portal_cta: 'Tôi đồng ý, đến Cổng Bệnh Nhân',

    demographics_success_title: 'Bạn đã sẵn sàng!',
    demographics_success_body:
      'Cảm ơn bạn đã hoàn thành thông tin. Bây giờ bạn có thể quay lại cuộc trò chuyện với nhà cung cấp Tap Telehealth — họ đã sẵn sàng hỗ trợ. Vui lòng cho họ biết rằng bạn đã hoàn thành biểu mẫu này.',
    demographics_back_to_chat: 'Quay lại Chat',

    // Intake
    intake_closed_title: 'Biểu mẫu này không còn khả dụng',
    intake_closed_body: 'Nhà cung cấp dịch vụ sẽ thu thập thông tin của bạn trong cuộc trò chuyện.',
    intake_who_title: 'Hôm nay ai cần được chăm sóc?',
    intake_who_self: 'Tôi',
    intake_who_self_description: 'Tôi là bệnh nhân',
    intake_who_child: 'Con tôi',
    intake_who_child_description: 'Tôi là cha mẹ hoặc người giám hộ hợp pháp và sẽ thêm con tôi',
    intake_under_18_link: 'Tôi dưới 18 tuổi',
    intake_under_18_notice:
      'Chúng tôi chỉ có thể chăm sóc bệnh nhân dưới 18 tuổi khi có cha mẹ hoặc người giám hộ hợp pháp. Vui lòng nhờ cha mẹ hoặc người giám hộ tiếp tục điền biểu mẫu này cùng bạn, hoặc nhắn tin cho chúng tôi từ điện thoại của họ.',
    intake_under_18_confirm: 'Tôi hiểu',
    intake_minor_success_title: 'Cảm ơn bạn đã cho chúng tôi biết',
    intake_minor_success_body:
      'Vui lòng để cha mẹ hoặc người giám hộ ở gần bạn. Nhà cung cấp dịch vụ sẽ sớm liên hệ với bạn trong cuộc trò chuyện tin nhắn.',
    intake_stepper_guardian: 'Cha mẹ hoặc người giám hộ (bạn)',
    intake_stepper_child: 'Con của bạn',
    intake_guardian_title: 'Trước tiên, hãy cho chúng tôi biết về bạn',
    intake_guardian_notice:
      'Bước 1 là về bạn. Là cha mẹ hoặc người giám hộ hợp pháp, bạn là chủ tài khoản. Bạn sẽ thêm con mình ở bước tiếp theo.',
    intake_children_title: 'Bây giờ, về con của bạn',
    intake_children_intro:
      'Con bạn sẽ dùng chung số điện thoại và địa chỉ nhà với bạn. Sự đồng ý của bạn được áp dụng thay mặt cho con. Lần khám này sẽ dành cho con bạn.',
    intake_child_heading: 'Con {{number}}',
    intake_child_born: 'sinh ngày {{dob}}',
    intake_remove_child: 'Xóa',
    intake_add_child: 'Thêm con khác',
    intake_visit_for_title: 'Lần khám này dành cho con nào?',
    intake_visit_for_required: 'Vui lòng chọn người được khám',
    intake_confirm_children: 'Con',
    intake_confirm_visit_for: 'Lần khám này dành cho',
    intake_confirm_patient: 'Bệnh nhân',
    intake_confirm_guardian: 'Cha mẹ hoặc người giám hộ',
    intake_confirm_children_consent:
      'Là cha mẹ hoặc người giám hộ hợp pháp, các sự đồng ý của bạn ở trên cũng áp dụng cho những người con bạn đã thêm.',
    intake_email_in_use: 'Email này đã được sử dụng. Hãy để trống hoặc nhập email khác.',
    intake_success_body: 'Hãy quay lại cuộc trò chuyện tin nhắn — nhà cung cấp dịch vụ sẽ sớm hỗ trợ bạn.',
    intake_adult_dob_child_hint:
      'Bạn phải từ 18 tuổi trở lên. Biểu mẫu này là về bạn, người lớn đang liên hệ với chúng tôi. Nếu bạn liên hệ vì con mình, hãy giữ thông tin của bạn ở đây và thêm con bạn ở bước tiếp theo.',

    demographics_lastword_title: 'Chúng tôi tôn trọng lựa chọn của bạn!',
    demographics_lastword_body_line1:
      'Chúng tôi hiểu và tôn trọng lựa chọn của bạn. Hiện tại, Tap Telehealth chỉ có thể cung cấp dịch vụ chăm sóc qua khám từ xa (tin nhắn, điện thoại hoặc video). Rất tiếc, hôm nay chúng tôi chưa thể cung cấp dịch vụ trực tiếp hoặc lựa chọn khác.',
    demographics_lastword_body_line2:
      'Nếu muốn, bạn luôn có thể liên hệ lại khi khám từ xa phù hợp với bạn. Trong lúc này, nếu cần chăm sóc y tế khẩn cấp, vui lòng gọi 911 hoặc đến phòng cấp cứu gần nhất.',

    // Demographics validation
    demographics_validation_first_name_required: 'Tên là bắt buộc',
    demographics_validation_last_name_required: 'Họ là bắt buộc',
    demographics_validation_email_invalid: 'Vui lòng nhập địa chỉ email hợp lệ',
    demographics_validation_dob_required: 'Ngày sinh là bắt buộc',
    demographics_validation_dob_format: 'Vui lòng nhập ngày theo định dạng MM/DD/YYYY',
    demographics_validation_dob_month: 'Vui lòng nhập tháng hợp lệ',
    demographics_validation_dob_day: 'Vui lòng nhập ngày hợp lệ',
    demographics_validation_dob_year: 'Vui lòng nhập năm hợp lệ',
    demographics_validation_dob_future: 'Ngày sinh không thể ở tương lai',
    demographics_validation_dob_valid: 'Vui lòng nhập ngày hợp lệ',
    demographics_validation_gender_required: 'Vui lòng chọn giới tính',
    demographics_validation_phone_required: 'Số điện thoại là bắt buộc',
    demographics_phone: 'Số điện thoại',
    validation_numbers_only: 'Chỉ được nhập số!',
    demographics_validation_address_required: 'Địa chỉ là bắt buộc',
    demographics_validation_city_required: 'Thành phố là bắt buộc',
    demographics_validation_zip_required: 'Mã bưu chính là bắt buộc',
    demographics_validation_state_required: 'Tiểu bang là bắt buộc',
    demographics_validation_address_select: 'Vui lòng chọn một địa chỉ từ gợi ý',
    demographics_address_placeholder: 'Bắt đầu nhập địa chỉ của bạn...',
    demographics_heard_about_service_label: 'Bạn lần đầu biết về dịch vụ của chúng tôi như thế nào?',
    demographics_heard_about_service_other: 'Khác (vui lòng chỉ rõ)',
    demographics_heard_about_service_friend: 'Bạn bè hoặc thành viên gia đình',
    demographics_heard_about_service_community: 'Sự kiện cộng đồng',
    demographics_heard_about_service_social: 'Mạng xã hội',
    demographics_heard_about_service_google: 'Google',
    demographics_heard_about_service_specify: 'Vui lòng chỉ rõ cách bạn biết về dịch vụ của chúng tôi',

    // Patient Portal - Medical History page and related components
    medical_history_title: 'Tiền sử y tế',
    medical_history_description:
      'Theo dõi tiền sử y tế của bạn tại đây để chúng tôi luôn có thông tin mới nhất nhằm cung cấp dịch vụ chăm sóc hiệu quả nhất.',
    medical_history_pdf_filename: 'TienSuYTe.pdf',

    title_section_download_pdf: 'Tải xuống (PDF)',
    title_section_see_chat: 'Xem chat',

    sidebar_medical_history: 'Tiền sử y tế',
    sidebar_personal_info: 'Thông tin cá nhân',
    personal_info_general_title: 'Thông tin chung',

    // Past Sessions
    no_sessions_available: 'Không có phiên nào',
    no_diagnosis_available: 'Không có chẩn đoán',
    past_session_label: 'Phiên trước',
    end_of_chat_title: 'Kết thúc cuộc trò chuyện',
    encounter_closed_message: 'Cuộc khám này đã kết thúc. Nếu bạn cần hỗ trợ thêm, vui lòng kết nối với bác sĩ.',
    connect_me_with_doctor: 'Kết nối tôi với bác sĩ',
    handouts_title: 'Tài liệu',
    additional_notes: 'Ghi chú bổ sung',
    no_files_available: 'Không có tệp nào',
    excuse_notes_title: 'Giấy xin phép',
    excuse_note_title_work: 'Giấy nghỉ làm',
    excuse_note_title_school: 'Giấy nghỉ học',
    excuse_note_title_other: 'Giấy xác nhận nghỉ',
    excuse_note_open_error: 'Chúng tôi không mở được giấy xác nhận này. Vui lòng thử lại.',
    no_excuse_notes_available: 'Không có giấy xin phép nào',
    prescriptions_title: 'Đơn thuốc',
    no_prescriptions_available: 'Không có đơn thuốc nào',
    referrals_title: 'Giấy giới thiệu',
    no_referrals_available: 'Không có giấy giới thiệu nào',
    summary_title: 'Tóm tắt',
    no_data: 'Không có dữ liệu',
    no_data_available: 'Không có dữ liệu',
    no_date_available: 'Không có ngày',

    // Footer brand heading
    footer_brand_heading: 'TAP TELEHEALTH',

    // Medical History - Allergies Card
    mh_allergies_title: 'Dị ứng',
    mh_allergies_intro: 'Biết về các dị ứng của bạn giúp chúng tôi kê đơn chính xác hơn và phòng ngừa phản ứng.',
    mh_allergies_yesno_question: 'Bạn có bị dị ứng nào không (thuốc, thực phẩm, v.v.)?',
    mh_allergies_none_label: 'Không có dị ứng đã biết',
    mh_allergies_add_btn: 'Thêm dị ứng',
    mh_allergies_none_cta: 'Tôi không có dị ứng nào',
    mh_allergies_form_name_label: 'Tên',
    mh_allergies_form_name_required: 'Vui lòng chọn dị ứng',
    mh_allergies_form_reaction_label: 'Phản ứng',
    mh_allergies_reaction_prefix: 'Phản ứng',

    // Medical History - Medications Card
    mh_medications_title: 'Thuốc đang dùng',
    mh_medications_intro: 'Biết các thuốc bạn đang dùng giúp chúng tôi tránh tương tác và chăm sóc an toàn hơn.',
    mh_medications_yesno_question:
      'Hiện tại bạn có dùng thuốc thường xuyên để điều trị bất kỳ tình trạng sức khỏe nào không?',
    mh_medications_none_label: 'Không có thuốc nào hiện tại',
    mh_medications_add_btn: 'Thêm thuốc',
    mh_medications_none_cta: 'Tôi không dùng thuốc nào thường xuyên',
    mh_medications_form_drug_label: 'Tên thuốc',
    mh_medications_form_drug_required: 'Vui lòng chọn thuốc',
    mh_medications_form_dosage_label: 'Liều lượng',
    mh_medications_form_dosage_required: 'Vui lòng nhập liều lượng',
    mh_medications_form_dosage_placeholder: 'Tìm thuốc trước để thay đổi liều.',
    mh_medications_form_frequency_label: 'Tần suất',

    // Medical History - Measurements Card
    mh_measurements_title: 'Chỉ số đo',
    mh_measurements_intro: 'Cung cấp cân nặng và chiều cao giúp chúng tôi điều chỉnh điều trị và liều thuốc phù hợp.',
    mh_measurements_height_label: 'Chiều cao của bạn là bao nhiêu?',
    mh_measurements_height_feet_required: 'Vui lòng nhập số feet',
    mh_measurements_height_feet_placeholder: 'ft',
    mh_measurements_height_inches_placeholder: 'in',
    mh_measurements_weight_label: 'Cân nặng của bạn là bao nhiêu?',
    mh_measurements_weight_required: 'Vui lòng nhập cân nặng',
    mh_measurements_weight_placeholder: 'lbs',
    mh_measurements_view_height: 'Chiều cao',
    mh_measurements_view_weight: 'Cân nặng',

    // Medical History - Health Problems Card
    mh_healthproblems_title: 'Vấn đề sức khỏe',
    mh_healthproblems_intro:
      'Chia sẻ tiền sử y tế giúp chúng tôi hiểu rõ sức khỏe của bạn hơn và cung cấp chăm sóc cá nhân hóa.',
    mh_healthproblems_none_label: 'Không có vấn đề sức khỏe đã biết',
    mh_healthproblems_add_btn: 'Thêm vấn đề sức khỏe',
    mh_healthproblems_none_cta: 'Tôi không có vấn đề sức khỏe nào',
    mh_healthproblems_other_placeholder: 'Vui lòng ghi rõ...',

    // Medical History - Family History Card
    mh_familyhistory_title: 'Tiền sử gia đình',
    mh_familyhistory_intro: 'Hiểu tiền sử y tế gia đình giúp chúng tôi đánh giá nguy cơ sức khỏe và chăm sóc chủ động.',
    mh_familyhistory_yesno_question:
      'Có thành viên nào trong gia đình bạn mắc bệnh mạn tính (ví dụ: tiểu đường, bệnh tim, hoặc tình trạng mạn tính khác) không?',
    mh_familyhistory_none_label: 'Không có vấn đề gia đình đã biết',
    mh_familyhistory_add_btn: 'Thêm tiền sử gia đình',
    mh_familyhistory_none_cta: 'Không ai trong gia đình tôi có bệnh lý mạn tính',
    mh_familyhistory_other_placeholder: 'Vui lòng ghi rõ...',

    // Medical History - Lifestyle Card
    mh_lifestyle_title: 'Lối sống',
    mh_lifestyle_intro:
      'Thông tin về lối sống giúp chúng tôi hiểu các yếu tố ảnh hưởng đến sức khỏe và chăm sóc của bạn.',
    mh_lifestyle_smoking_question:
      'Hiện tại bạn có hút thuốc hay vape (ví dụ: thuốc lá, thuốc lá điện tử hoặc các sản phẩm vape khác) không?',
    mh_lifestyle_yes_smoke: 'Có, tôi hút thuốc',
    mh_lifestyle_yes_vape: 'Có, tôi vape',
    mh_lifestyle_yes_both: 'Có, tôi vừa hút thuốc vừa vape',
    mh_lifestyle_drinking_question: 'Bạn có uống rượu không?',
    mh_lifestyle_view_smoking_label: 'Hút thuốc/Vape',
    mh_lifestyle_view_drinking_label: 'Uống rượu',
    mh_lifestyle_no_response: 'Không có phản hồi',

    // Medical History - Surgical History Card
    mh_surgical_title: 'Tiền sử phẫu thuật',
    mh_surgical_intro: 'Biết tiền sử phẫu thuật giúp chúng tôi tránh biến chứng và điều trị an toàn hơn.',
    mh_surgical_yesno_question: 'Bạn đã từng phẫu thuật trong quá khứ chưa?',
    mh_surgical_none_label: 'Không có phẫu thuật',
    mh_surgical_add_btn: 'Thêm phẫu thuật',
    mh_surgical_none_cta: 'Tôi chưa từng phẫu thuật trong quá khứ',
    mh_surgical_form_surgery_label: 'Phẫu thuật',
    mh_surgical_form_surgery_required: 'Vui lòng chọn một lựa chọn',
    // Patient Portal - Emergency Contacts
    emergency_contacts_title: 'Liên hệ khẩn cấp',
    emergency_contacts_intro:
      'Vui lòng thêm thông tin liên hệ của những người bạn cho phép chúng tôi liên lạc trong trường hợp khẩn cấp.',
    emergency_contacts_add_btn: 'Thêm liên hệ khẩn cấp',
    relationship: 'Mối quan hệ',
    validation_select_option: 'Chọn một tùy chọn',

    // Relationship types (from RelationshipType enum)
    relationship_type_emergency_contact: 'Liên hệ khẩn cấp',
    relationship_type_guardian: 'Người giám hộ',
    relationship_type_next_of_kin: 'Người thân gần nhất',
    relationship_type_caregiver: 'Người chăm sóc',
    relationship_type_parent: 'Cha/Mẹ',
    relationship_type_child: 'Con',
    relationship_type_spouse: 'Vợ/Chồng',
    relationship_type_sibling: 'Anh/Chị/Em',
    relationship_type_mother: 'Mẹ',
    relationship_type_father: 'Cha',
    relationship_type_son: 'Con trai',
    relationship_type_daughter: 'Con gái',
    relationship_type_grandmother: 'Bà',
    relationship_type_grandfather: 'Ông',
    relationship_type_granddaughter: 'Cháu gái',
    relationship_type_grandson: 'Cháu trai',
    relationship_type_aunt: 'Dì/Cô',
    relationship_type_uncle: 'Chú/Bác',
    relationship_type_niece: 'Cháu gái',
    relationship_type_nephew: 'Cháu trai',
    relationship_type_cousin: 'Anh/Chị/Em họ',
    relationship_type_legal_guardian: 'Người giám hộ hợp pháp',
    relationship_type_foster_parent: 'Cha/Mẹ nuôi',
    relationship_type_adoptive_parent: 'Cha/Mẹ nuôi nhận',
    relationship_type_step_parent: 'Cha dượng/Mẹ kế',
    relationship_type_step_son: 'Con trai riêng',
    relationship_type_step_daughter: 'Con gái riêng',
    relationship_type_foster_son: 'Con trai nuôi',
    relationship_type_foster_daughter: 'Con gái nuôi',
    relationship_type_step_sibling: 'Anh/Chị/Em kế',
    relationship_type_in_law: 'Bên thông gia',
    relationship_type_domestic_partner: 'Bạn đời',
    relationship_type_lawyer: 'Luật sư',
    relationship_type_doctor: 'Bác sĩ',
    relationship_type_therapist: 'Chuyên viên trị liệu',
    relationship_type_social_worker: 'Nhân viên xã hội',
    relationship_type_case_manager: 'Quản lý ca bệnh',
    relationship_type_nurse: 'Y tá/Điều dưỡng',
    relationship_type_neighbor: 'Hàng xóm',
    relationship_type_coworker: 'Đồng nghiệp',
    relationship_type_roommate: 'Bạn cùng phòng',
    relationship_type_mentor: 'Người cố vấn',
    relationship_type_mentee: 'Người được cố vấn',
    relationship_type_religious_leader: 'Lãnh đạo tôn giáo',
    relationship_type_volunteer: 'Tình nguyện viên',
    relationship_type_colleague: 'Đồng nghiệp',
    relationship_type_supervisor: 'Người giám sát',
    relationship_type_subordinate: 'Cấp dưới',
    relationship_type_godparent: 'Cha/Mẹ đỡ đầu',
    relationship_type_godchild: 'Con đỡ đầu',
    relationship_type_ward: 'Người được giám hộ',
    relationship_type_sponsor: 'Người bảo trợ',
    relationship_type_benefactor: 'Ân nhân',
    relationship_type_friend: 'Bạn bè',
    relationship_type_acquaintance: 'Người quen',
    relationship_type_partner: 'Bạn đời/Đối tác',
    relationship_type_other: 'Khác',

    minor_guardian_relationship_mother: 'Mẹ',
    minor_guardian_relationship_father: 'Cha',
    minor_guardian_relationship_aunt: 'Dì/Cô',
    minor_guardian_relationship_uncle: 'Chú/Bác',
    minor_guardian_relationship_grandmother: 'Bà',
    minor_guardian_relationship_grandfather: 'Ông',
    minor_guardian_relationship_son: 'Con trai',
    minor_guardian_relationship_daughter: 'Con gái',
    minor_guardian_relationship_step_son: 'Con trai riêng',
    minor_guardian_relationship_step_daughter: 'Con gái riêng',
    minor_guardian_relationship_step_mother: 'Mẹ kế',
    minor_guardian_relationship_step_father: 'Cha dượng',
    minor_guardian_relationship_foster_son: 'Con trai nuôi',
    minor_guardian_relationship_foster_daughter: 'Con gái nuôi',
    minor_guardian_relationship_foster_mother: 'Mẹ nuôi',
    minor_guardian_relationship_foster_father: 'Cha nuôi',
    minor_guardian_relationship_ward: 'Người được giám hộ',
    minor_guardian_relationship_grandson: 'Cháu trai',
    minor_guardian_relationship_granddaughter: 'Cháu gái',
    minor_guardian_relationship_niece: 'Cháu gái (gọi dì/cô/bác)',
    minor_guardian_relationship_nephew: 'Cháu trai (gọi chú/bác)',
    minor_guardian_relationship_cousin: 'Anh/chị/em họ',
    minor_guardian_relationship_other: 'Khác',

    // Patient Portal - Pharmacy Step
    pharmacy_search_label: 'Tìm nhà thuốc',
    pharmacy_search_placeholder: 'Tìm theo tên, địa chỉ hoặc mã ZIP',

    // Stepper - Completion messages
    stepper_finish_title: 'Hoàn tất!',
    stepper_finish_btn_home: 'Quay lại trang chủ',
    stepper_finish_desc:
      'Chúng tôi trân trọng thời gian và nỗ lực bạn chia sẻ thông tin. Điều này giúp chúng tôi cung cấp dịch vụ an toàn, cá nhân hóa và ưu tiên sức khỏe của bạn.',
    stepper_close_btn: 'Đóng',
    stepper_thankyou_title: 'Cảm ơn!',
    stepper_finish_description:
      'Thông tin của bạn đã được gửi thành công. Vui lòng quay lại cuộc trò chuyện với bác sĩ để tiếp tục trao đổi và nhận hướng dẫn thêm.',
    mh_surgical_form_other_label: 'Ghi rõ phẫu thuật khác',
    mh_surgical_form_other_required: 'Vui lòng ghi rõ loại phẫu thuật',
    mh_surgical_form_other_placeholder: 'Nhập tên phẫu thuật',

    // Medical History - PDF
    pdf_medical_history_title: 'TIỀN SỬ Y TẾ',
    pdf_label_gender: 'Giới tính',
    pdf_label_dob: 'Ngày sinh',
    pdf_label_height: 'Chiều cao',
    pdf_label_weight: 'Cân nặng',
    pdf_label_office: 'Văn phòng',
    pdf_label_website: 'Website',
    pdf_label_email: 'Email',
    pdf_past_sessions_title: 'CÁC PHIÊN TRƯỚC',
    // Auth - Recover Password
    email_required: 'Vui lòng nhập email của bạn',
    unknown_error_try_again: 'Lỗi không xác định, vui lòng thử lại sau.',

    // Auth - Send Code / Enter Code / Send Mail
    sendcode_title: 'Kênh liên hệ trực tiếp để được chăm sóc',
    sendcode_description:
      'Nhập số điện thoại di động của bạn để nhận mã xác minh qua SMS. Có thể áp dụng phí của nhà mạng.',
    need_assistance: 'Cần hỗ trợ?',
    reach_out_at: 'Liên hệ với chúng tôi tại',
    read_prefix: 'Đọc TapTelehealth',
    terms_and_conditions: 'Điều khoản & Điều kiện',
    enter_code_title: 'Nhập mã của bạn',
    enter_code_phone_sent: 'Chúng tôi đã gửi mã đến số điện thoại của bạn có 4 số cuối là',
    enter_code_email_sent: 'Chúng tôi đã gửi mã đến email của bạn',
    enter_code_enter_below: 'Nhập mã bên dưới để xác minh tài khoản.',
    enter_code_send_new: 'Gửi mã mới',
    enter_code_required: 'Vui lòng nhập mã xác minh',
    enter_code_must_be_6_digits: 'Mã phải gồm đúng 6 chữ số',
    verify_cta: 'Xác minh',
    send_code_cta: 'Gửi mã',
    mobile_phone_number_label: 'Số điện thoại di động',
    must_agree_to_continue: 'Bạn phải đồng ý để tiếp tục',
    messaging_consent_text:
      'Tôi đồng ý nhận tin nhắn SMS từ Tap Telehealth về thông tin sức khỏe chung và các cập nhật liên quan đến dịch vụ. Tôi hiểu rằng có thể áp dụng cước tin nhắn và dữ liệu và tần suất tin nhắn có thể thay đổi. Tôi có thể hủy đăng ký bất cứ lúc nào thông qua <portalLink>Cổng Bệnh Nhân Tap Telehealth</portalLink> hoặc bằng cách trả lời STOP cho bất kỳ tin nhắn nào. Tìm hiểu thêm trong <termsLink>Điều khoản Dịch vụ</termsLink> và <privacyLink>Chính sách quyền riêng tư</privacyLink> của chúng tôi, hoặc bằng cách trả lời HELP cho bất kỳ tin nhắn nào.',
    email_consent_text: 'Tôi đồng ý nhận thông tin và cập nhật liên quan đến sức khỏe qua email.',

    // Auth - Household
    household_where_located_title: 'Bạn đang ở đâu?',
    household_where_located_desc:
      'Cung cấp địa chỉ giúp chúng tôi kết nối bạn với nhà cung cấp dịch vụ y tế phù hợp một cách nhanh chóng.',

    // Survey Module - Survey Steps
    survey_info_title: 'Hãy giúp chúng tôi cá nhân hóa việc chăm sóc cho bạn',
    survey_info_button: 'Bắt đầu',
    survey_info_description_part1:
      'Trước khi hoàn tất đơn thuốc, chúng tôi muốn thu thập một số thông tin sức khỏe quan trọng. Bảng khảo sát ngắn này',
    survey_info_description_part2: 'giúp chúng tôi đảm bảo an toàn cho bạn và cung cấp dịch vụ chăm sóc tốt nhất',
    survey_all_done_title: 'Cảm ơn!',
    survey_all_done_description:
      'Thông tin của bạn đã được gửi thành công. Vui lòng quay lại trò chuyện với bác sĩ để tiếp tục và nhận hướng dẫn thêm.',

    // Survey Module - Allergies Card
    survey_allergies_title: 'Dị ứng',
    survey_allergies_title_minor: 'Dị ứng của trẻ',
    survey_allergies_question: 'Bạn có dị ứng nào không (thuốc, thực phẩm, v.v.)?',
    survey_allergies_question_minor: 'Trẻ vị thành niên của bạn có dị ứng nào không (thuốc, thực phẩm, v.v.)?',
    survey_allergies_intro: 'Chia sẻ thông tin về dị ứng giúp đảm bảo kê đơn an toàn hơn và tránh phản ứng bất lợi.',
    survey_allergies_intro_minor:
      'Chia sẻ thông tin dị ứng này giúp đảm bảo kê đơn an toàn hơn và tránh phản ứng bất lợi.',
    survey_allergies_no_cta: 'Không, tôi không có dị ứng nào',
    survey_allergies_no_cta_minor: 'Không, trẻ không có dị ứng nào',
    survey_allergies_yes_add: 'Có, thêm dị ứng',
    survey_allergies_form_name_label: 'Tên dị ứng',
    survey_allergies_form_name_required: 'Vui lòng chọn dị ứng',
    survey_allergies_form_reaction_label: 'Phản ứng (Chọn tất cả những gì áp dụng):',
    survey_allergies_form_other_placeholder: 'Vui lòng ghi rõ',
    survey_allergies_form_other_required: 'Vui lòng ghi rõ phản ứng',
    survey_allergies_add_btn: 'Thêm dị ứng',
    survey_allergies_confirm_question: 'Thông tin dị ứng này đã đúng và đầy đủ chưa?',
    survey_allergies_no_update: 'Không, tôi cần thêm dị ứng',
    survey_allergies_reaction_rash: 'Phát ban/Mề đay',
    survey_allergies_reaction_swelling: 'Sưng',
    survey_allergies_reaction_breathing: 'Khó thở',
    survey_allergies_reaction_anaphylaxis: 'Sốc phản vệ',
    survey_allergies_reaction_gastro: 'Triệu chứng tiêu hóa',
    survey_allergies_reaction_itching: 'Ngứa',
    survey_allergies_reaction_other: 'Khác',

    // Survey Module - Pharmacy Card
    survey_pharmacy_title: 'Chọn nhà thuốc',
    survey_pharmacy_search_label: 'Tìm nhà thuốc',
    survey_pharmacy_search_placeholder: 'Tìm theo tên, địa chỉ hoặc mã ZIP',
    survey_pharmacy_add_btn: '+ Thêm',
    survey_pharmacy_confirm_question: 'Nhà thuốc này đã đúng chưa?',
    survey_pharmacy_no_update: 'Không, tôi cần cập nhật nhà thuốc',

    // Survey Module - Height Card
    survey_height_title: 'Chiều cao',
    survey_height_title_minor: 'Chiều cao của trẻ',
    survey_height_label: 'Chiều cao của bạn',
    survey_height_label_minor: 'Chiều cao của trẻ',
    survey_height_feet_required: 'Vui lòng nhập số feet',
    survey_height_inches_required: 'Vui lòng nhập số inches',

    // Survey Module - Weight Card
    survey_weight_title: 'Cân nặng',
    survey_weight_title_minor: 'Cân nặng của trẻ',
    survey_weight_label: 'Cân nặng của bạn (lbs)',
    survey_weight_label_minor: 'Cân nặng của trẻ (lbs)',

    // Survey Module - First Question
    survey_q1_title: 'Hãy cho chúng tôi biết về các lựa chọn chăm sóc y tế của bạn',
    survey_q1_question: 'Nếu không có Tap Telehealth hôm nay, bạn sẽ nhận chăm sóc bằng cách nào?',
    survey_q1_instruction: 'Vui lòng chọn nội dung phù hợp nhất với tình huống của bạn.',
    survey_q1_option1_title: 'Không có cách nào để nhận chăm sóc y tế',
    survey_q1_option1_description:
      'Phải gọi 911 do thiếu phương tiện di chuyển, khó lái xe khi ốm hoặc hạn chế vận động.',
    survey_q1_option1_italic: '(Phổ biến với nhiều bệnh nhân)',
    survey_q1_option2_title: 'Không có lựa chọn chăm sóc ngay lập tức gần đó',
    survey_q1_option2_description:
      'Phòng cấp cứu là lựa chọn duy nhất để được khám trong ngày do thời gian, vị trí hoặc cần khám ngoài giờ.',
    survey_q1_option2_italic: '(Tình huống phổ biến nhất)',
    survey_q1_option3_title: 'Có thể đi khám khẩn cấp (Urgent care)',
    survey_q1_option3_description:
      'Có phương tiện di chuyển và có thể trả đồng chi trả $50-145, nhưng phải chờ 1–2 giờ.',
    survey_q1_option4_title: 'Bác sĩ của tôi có thể khám nhanh',
    survey_q1_option4_description:
      'Có bác sĩ gia đình với lịch hẹn trong/ngày hôm sau và triệu chứng có thể chờ đến lúc đó.',
    survey_q1_option5_title: 'Tôi sẽ tự theo dõi ở nhà',
    survey_q1_option5_description: 'Tôi sẽ tự chăm sóc tại nhà mà không tìm kiếm hỗ trợ y tế chuyên nghiệp.',

    // Survey Module - Second Question
    survey_q2_title: 'Tiết kiệm thời gian',
    survey_q2_info_line1: 'Khám trực tiếp thường đồng nghĩa:',
    survey_q2_info_line2: '• 3–4 giờ cho một cuộc hẹn (di chuyển + chờ đợi + khám)',
    survey_q2_info_line3: '• Hầu hết mọi người nghỉ cả ngày làm/học để đi khám',
    survey_q2_info_line4: '• Nếu không điều trị sớm, triệu chứng thường kéo dài thêm 2–3 ngày',
    survey_q2_question: 'Tap Telehealth đã giúp bạn tiết kiệm bao nhiêu ngày làm/học?',
    survey_q2_option1: '3+ ngày (tính cả thời gian hẹn và phục hồi nhanh hơn)',
    survey_q2_option2: '2 ngày (phổ biến khi điều trị sớm giúp giảm triệu chứng nhanh hơn)',
    survey_q2_option3: '1 ngày (điển hình với 1 lần khám trực tiếp)',
    survey_q2_option4: 'Ít hơn 1 ngày',
    survey_q2_option5: 'Không áp dụng (không đi làm/đi học)',

    // Survey Module - Third Question
    survey_q3_title: 'Tiết kiệm thời gian',
    survey_q3_subtitle: 'Trải nghiệm của bạn với dịch vụ của chúng tôi',
    survey_q3_info_line1: 'Khám từ xa thường giúp bệnh nhân tiết kiệm:',
    survey_q3_info_line2: '• 2–4 giờ di chuyển và chờ đợi',
    survey_q3_info_line3: '• $50–250 chi phí',
    survey_q3_info_line4: '• Sự bất tiện khi sắp xếp phương tiện',
    survey_q3_slider1_label: 'Bạn có sẵn sàng giới thiệu Tap Telehealth không?',
    survey_q3_slider1_min: 'Không sẵn sàng',
    survey_q3_slider1_max: 'Rất sẵn sàng',
    survey_q3_slider2_label: 'Tap Telehealth tốt hơn bao nhiêu so với đi cấp cứu hoặc urgent care?',
    survey_q3_slider2_min: 'Không tốt hơn',
    survey_q3_slider2_max: 'Tốt hơn rất nhiều',
    survey_q3_slider3_label: 'Mức độ dễ sử dụng dịch vụ Tap Telehealth?',
    survey_q3_slider3_min: 'Rất khó',
    survey_q3_slider3_max: 'Rất dễ',
    survey_q3_submit_btn: 'Gửi',

    // Survey Module - Fourth Question
    survey_q4_title: 'Bảo hiểm',
    survey_q4_info:
      'Chi phí của bạn là bất kể bạn được bảo hiểm như thế nào - chúng tôi chỉ hỏi để hiểu ai đang sử dụng TAP. Đây là tùy chọn.',
    survey_q4_question: 'Bạn hiện có bảo hiểm y tế hoặc Medicaid không?',
    survey_q4_option1: 'Bảo hiểm tư nhân / do công ty cung cấp',
    survey_q4_option2: 'Medicaid',
    survey_q4_option3: 'Medicare',
    survey_q4_option4: 'Không có bảo hiểm ngay bây giờ',
    survey_q4_option5: 'Không muốn nói',

    // Survey Module - Additional Feedback
    survey_feedback_title: 'Phản hồi bổ sung',
    survey_feedback_subtitle:
      'Chia sẻ bất cứ điều gì khác về trải nghiệm của bạn với Tap Telehealth. Phản hồi của bạn giúp chúng tôi cải thiện dịch vụ.',
    survey_feedback_info:
      'Vui lòng không bao gồm bất kỳ thông tin cá nhân hoặc y tế nào trong phản hồi của bạn như tên, thông tin liên hệ hoặc bất kỳ thông tin nào khác có thể nhận dạng bạn.',
    survey_feedback_placeholder: 'Phản hồi của bạn',
    survey_feedback_consent:
      'Tôi đồng ý rằng phản hồi hoặc đánh giá của tôi có thể được Tap Telehealth chia sẻ công khai, như trên trang web hoặc mạng xã hội của chúng tôi, mà không có bất kỳ thông tin cá nhân hoặc nhận dạng nào.',
    survey_feedback_submit_btn: 'Gửi',

    // Survey Module - Savings Card
    survey_savings_title: 'Đây là chuyến thăm của bạn, theo con số.',
    survey_savings_subtitle: 'Ước tính thận trọng về chi phí hôm nay nếu bạn đi nơi khác.',

    // Survey Module - Advocate
    survey_thank_you_title: 'Cảm ơn bạn - điều này thực sự giúp ích',
    survey_thank_you_text:
      'Phản hồi trung thực của bạn giúp TAP trở nên tốt hơn cho bạn và những người hàng xóm của bạn. Chúng tôi đã chuyển nó đến đội ngũ chăm sóc.',
    survey_advocate_no_medical_care_title: 'Bạn đã bỏ qua cánh cửa đắt nhất.',
    survey_advocate_no_care_options_title:
      'Bạn đã xử lý bằng một tin nhắn những gì thường tốn $1,500 và cả buổi chiều.',
    survey_advocate_urgent_care_title: 'Không đồng thanh toán. Không phòng chờ. Không mất buổi chiều.',
    survey_advocate_doctor_quick_title: 'Bạn có một bác sĩ mà bạn có thể liên hệ. Nhiều người hàng xóm thì không.',
    survey_advocate_waited_out_title: 'Bạn không chờ đợi và xem. Điều đó quan trọng hơn bạn nghĩ.',
    survey_advocate_no_medical_care_text:
      'Một tin nhắn thay vì xe cứu thương và phòng cấp cứu - đó là khoản chi khoảng $2,000 mà hầu hết các gia đình không bao giờ thấy trước, và bạn đã đi qua nó. Bây giờ hãy chỉ cho người hàng xóm cảm thấy họ không có lựa chọn khác nơi cánh cửa. Đó là điều làm bạn trở thành một trong những người ủng hộ tốt nhất của {{city}}.',
    survey_advocate_no_medical_care_text_no_city:
      'Một tin nhắn thay vì xe cứu thương và phòng cấp cứu - đó là khoản chi khoảng $2,000 mà hầu hết các gia đình không bao giờ thấy trước, và bạn đã đi qua nó. Bây giờ hãy chỉ cho người hàng xóm cảm thấy họ không có lựa chọn khác nơi cánh cửa.',
    survey_advocate_no_care_options_text:
      'Hầu hết mọi người không biết một tin nhắn có thể làm được điều đó - bạn biết. Vì vậy hãy nói với người hàng xóm sẽ lái xe đến phòng cấp cứu tối nay: một tin nhắn hai phút sẽ giải quyết được. Đó là điều làm bạn trở thành một trong những người ủng hộ tốt nhất của {{city}}.',
    survey_advocate_no_care_options_text_no_city:
      'Hầu hết mọi người không biết một tin nhắn có thể làm được điều đó - bạn biết. Vì vậy hãy nói với người hàng xóm sẽ lái xe đến phòng cấp cứu tối nay: một tin nhắn hai phút sẽ giải quyết được.',
    survey_advocate_urgent_care_text:
      'Bạn đã bỏ qua khoảng $115 và một giờ ngồi trên ghế nhựa cho điều gì đó mà một tin nhắn đã giải quyết. Nhân điều đó trên toàn khu phố và đó là tiền thật còn lại trong {{city}}. Hãy nói với một người hàng xóm - đó là điều làm bạn trở thành một trong những người ủng hộ tốt nhất của nó.',
    survey_advocate_urgent_care_text_no_city:
      'Bạn đã bỏ qua khoảng $115 và một giờ ngồi trên ghế nhựa cho điều gì đó mà một tin nhắn đã giải quyết. Hãy nói với một người hàng xóm - đó là điều làm bạn trở thành một trong những người ủng hộ tốt nhất của nó.',
    survey_advocate_doctor_quick_text:
      'Những người không kết thúc tại chăm sóc khẩn cấp hoặc phòng cấp cứu cho những việc mà một tin nhắn có thể đã giải quyết. Bạn có thể trao cho họ những gì bạn đã có - chỉ cho họ bác sĩ mà họ không biết họ có. Đó là điều làm bạn trở thành một trong những người ủng hộ tốt nhất của {{city}}.',
    survey_advocate_doctor_quick_text_no_city:
      'Những người không kết thúc tại chăm sóc khẩn cấp hoặc phòng cấp cứu cho những việc mà một tin nhắn có thể đã giải quyết. Bạn có thể trao cho họ những gì bạn đã có - chỉ cho họ bác sĩ mà họ không biết họ có.',
    survey_advocate_waited_out_text:
      'Điều bạn bỏ qua vào thứ Ba là chuyến đi đến phòng cấp cứu vào thứ Bảy - và bạn đã bỏ qua điều đó. Bây giờ hãy nói với người hàng xóm vẫn đang cố gắng: một tin nhắn hai phút có thể cứu họ một cuối tuần trong phòng chờ. Đó là điều làm bạn trở thành một trong những người ủng hộ tốt nhất của {{city}}.',
    survey_advocate_waited_out_text_no_city:
      'Điều bạn bỏ qua vào thứ Ba là chuyến đi đến phòng cấp cứu vào thứ Bảy - và bạn đã bỏ qua điều đó. Bây giờ hãy nói với người hàng xóm vẫn đang cố gắng: một tin nhắn hai phút có thể cứu họ một cuối tuần trong phòng chờ.',
    survey_advocate_share_button: 'Chia sẻ trải nghiệm của bạn →',

    // Survey Module - Share
    survey_share_title: 'Chia sẻ tình yêu (và tiết kiệm)!',
    survey_share_subtitle: 'Một lần nhấn - thẻ và chú thích của bạn đã sẵn sàng.',
    survey_share_caption_heading: 'Chú thích của bạn',
    survey_share_no_medical_care_caption:
      'Không thể đến gặp bác sĩ hôm nay - vì vậy tôi đã nhắn tin và nhận được những gì tôi cần trong vài phút. Đó là một chuyến đi ER/xe cứu thương khoảng $2,000 mà tôi không phải thực hiện. Thật tuyệt khi nhiều người không biết {{city}} có điều này. 💙 #ADoctorIsJustATapAway',
    survey_share_no_medical_care_caption_no_city:
      'Không thể đến gặp bác sĩ hôm nay - vì vậy tôi đã nhắn tin và nhận được những gì tôi cần trong vài phút. Đó là một chuyến đi ER/xe cứu thương khoảng $2,000 mà tôi không phải thực hiện. 💙 #ADoctorIsJustATapAway',
    survey_share_no_care_options_caption:
      'Nhắn tin cho một bác sĩ thực sự thay vì ngồi trong ER tối nay - trả lời và đơn thuốc trong khoảng 15 phút, không có hóa đơn $1,500. Nếu bạn ở {{city}}, bạn cũng có điều này. 💙 #ADoctorIsJustATapAway',
    survey_share_no_care_options_caption_no_city:
      'Nhắn tin cho một bác sĩ thực sự thay vì ngồi trong ER tối nay - trả lời và đơn thuốc trong khoảng 15 phút, không có hóa đơn $1,500. 💙 #ADoctorIsJustATapAway',
    survey_share_urgent_care_caption:
      'Bỏ qua đồng thanh toán chăm sóc khẩn cấp và phòng chờ - nhắn tin cho bác sĩ và xong trong vài phút. Điều nhỏ, nhưng nó cộng lại. Thật vui khi {{city}} có điều này. 💙 #ADoctorIsJustATapAway',
    survey_share_urgent_care_caption_no_city:
      'Bỏ qua đồng thanh toán chăm sóc khẩn cấp và phòng chờ - nhắn tin cho bác sĩ và xong trong vài phút. Điều nhỏ, nhưng nó cộng lại. 💙 #ADoctorIsJustATapAway',
    survey_share_doctor_quick_caption:
      'Tôi có một bác sĩ mà tôi có thể liên hệ - và bây giờ tôi có thể liên hệ bằng tin nhắn trong vài phút, ngày hay đêm. Nếu bạn không có bác sĩ mà bạn có thể đến, {{city}} sẽ cung cấp cho bạn một người. 💙 #ADoctorIsJustATapAway',
    survey_share_doctor_quick_caption_no_city:
      'Tôi có một bác sĩ mà tôi có thể liên hệ - và bây giờ tôi có thể liên hệ bằng tin nhắn trong vài phút, ngày hay đêm. 💙 #ADoctorIsJustATapAway',
    survey_share_waited_out_caption:
      'Thông thường tôi sẽ chỉ chịu đựng - thay vào đó tôi đã nhắn tin cho bác sĩ và phát hiện sớm. Hai phút tốt hơn một cuối tuần cảm thấy tồi tệ. {{city}} cũng có điều này nếu bạn cũng có. 💙 #ADoctorIsJustATapAway',
    survey_share_waited_out_caption_no_city:
      'Thông thường tôi sẽ chỉ chịu đựng - thay vào đó tôi đã nhắn tin cho bác sĩ và phát hiện sớm. Hai phút tốt hơn một cuối tuần cảm thấy tồi tệ. 💙 #ADoctorIsJustATapAway',
    survey_share_label: 'Chia sẻ',
    survey_share_facebook: 'Facebook',
    survey_share_x: 'Đăng trên X',
    survey_share_copy_caption: 'Sao chép chú thích',
    survey_share_save_card: 'Lưu hình ảnh thẻ',

    // Medical History Survey Module
    mhs_intro_title: 'Tổng quan sức khỏe của bạn',
    mhs_intro_description:
      'Vui lòng trả lời một vài câu hỏi nhanh để chúng tôi có thể hiểu rõ hơn về sức khỏe của bạn và cá nhân hóa việc chăm sóc.',
    mhs_medications_title: 'Thuốc đang dùng',
    mhs_medications_subtitle:
      'Liệt kê tất cả các loại thuốc bạn đang dùng, bao gồm thuốc kê đơn, thuốc không kê đơn, vitamin và thực phẩm chức năng',
    mhs_conditions_title: 'Tình trạng sức khỏe',
    mhs_conditions_subtitle: 'Chọn tất cả các tình trạng sức khỏe áp dụng cho bạn.',
    mhs_add_health_condition: 'Thêm tình trạng sức khỏe',
    mhs_surgical_title: 'Tiền sử phẫu thuật',
    mhs_surgical_subtitle:
      'Cho chúng tôi biết về bất kỳ ca phẫu thuật và thủ thuật nào bạn đã thực hiện trong quá khứ.',
    mhs_add_surgery: 'Thêm phẫu thuật',
    mhs_success_title: 'Cảm ơn bạn!',
    mhs_success_description: 'Bây giờ bạn có thể quay lại cuộc trò chuyện để tiếp tục với nhà cung cấp dịch vụ.',

    // Medical History Survey - UI
    mhs_search_medication_placeholder: 'Tìm kiếm thuốc',
    mhs_search_condition_placeholder: 'Tìm kiếm tình trạng',
    mhs_search_surgery_placeholder: 'Tìm kiếm thủ thuật phẫu thuật',
    mhs_most_common_medications: 'Thuốc phổ biến nhất',
    mhs_most_common_conditions: 'Tình trạng phổ biến nhất',
    mhs_most_common_surgeries: 'Phẫu thuật phổ biến nhất',
    mhs_no_medications: 'Tôi không dùng bất kỳ loại thuốc nào',
    mhs_other_medication_not_listed: 'Thuốc khác không có trong danh sách',
    mhs_no_conditions: 'Tôi không có bất kỳ tình trạng sức khỏe nào',
    mhs_other_condition_not_listed: 'Tình trạng khác không có trong danh sách',
    mhs_no_surgeries: 'Tôi chưa từng phẫu thuật',
    mhs_other_surgery_not_listed: 'Phẫu thuật khác không có trong danh sách',
    mhs_validation_select_option: 'Vui lòng chọn ít nhất một tùy chọn',
    mhs_medication_type_label: 'Loại:',
    mhs_medication_dose_label: 'Liều lượng/Hàm lượng:',
    mhs_medication_frequency_label: 'Tần suất dùng:',
    mhs_frequency_once_daily: 'Một lần mỗi ngày',
    mhs_frequency_twice_daily: 'Hai lần mỗi ngày',
    mhs_frequency_three_times_daily: 'Ba lần mỗi ngày',
    mhs_frequency_four_times_daily: 'Bốn lần mỗi ngày',
    mhs_frequency_as_needed: 'Khi cần',
    mhs_frequency_unknown: 'Tôi không biết',

    // Opt Out Module
    optout_title: 'Yêu cầu hủy đăng ký Tap Telehealth',
    optout_description:
      'Vui lòng điền vào biểu mẫu này để chúng tôi có thể chuyển tiếp yêu cầu của bạn đến Phòng Thanh toán Tiện ích Thành phố.',
    optout_account_number_label: 'Số tài khoản tiện ích',
    optout_submit_button: 'Gửi',
    optout_success_title: 'Cảm ơn!',
    optout_success_subtitle:
      'Cảm ơn bạn đã gửi yêu cầu. Chúng tôi sẽ chuyển tiếp thông tin của bạn đến Phòng Thanh toán Tiện ích Thành phố.',
    optout_error_message: 'Chúng tôi không thể gửi yêu cầu của bạn vào lúc này. Vui lòng thử lại sau.',
    optout_account_number_required: 'Vui lòng nhập số tài khoản tiện ích của bạn',

    // Opt In Module
    optin_title: 'Đăng ký lại {{programName}}',
    optin_description_opted_out_on: 'Hộ gia đình của bạn đã hủy đăng ký {{programName}} vào ngày {{optedOutDate}}.',
    optin_description_opted_out: 'Hộ gia đình của bạn đã hủy đăng ký {{programName}}.',
    optin_description_address: 'Địa chỉ được lưu là {{address}}.',
    optin_description_confirm: 'Nếu bạn muốn đăng ký lại, vui lòng chọn ô bên dưới và gửi yêu cầu.',
    optin_members_intro: 'Điều này sẽ khôi phục quyền truy cập cho:',
    optin_confirm_label: 'Tôi xác nhận muốn đăng ký lại',
    optin_link_expired_title: 'Liên kết này đã hết hạn',
    optin_link_expired_subtitle: 'Hãy nhắn tin lại cho chúng tôi để nhận liên kết mới.',
    optin_no_household_title: 'Không tìm thấy hộ gia đình',
    optin_no_household_subtitle: 'Chúng tôi không thể tìm thấy hộ gia đình liên kết với hồ sơ bệnh nhân của bạn.',
    optin_submit_button: 'Gửi',
    optin_success_title: 'Cảm ơn bạn!',
    optin_success_subtitle: 'Chúng tôi đã nhận được yêu cầu của bạn.',
    optin_error_message: 'Chúng tôi không thể gửi yêu cầu của bạn vào lúc này. Vui lòng thử lại sau.',
    optin_already_active_title: 'Không cần thực hiện thêm',
    optin_already_active_subtitle: 'Hộ gia đình của bạn đã đăng ký hoặc vừa yêu cầu cập nhật việc tham gia của mình.',

    // Demographics form token
    demographics_load_error_title: 'Chúng tôi không thể tải biểu mẫu của bạn',
    demographics_link_expired_title: 'Liên kết này đã hết hạn',
    demographics_link_expired_subtitle: 'Hãy nhắn tin cho nhà cung cấp của bạn để nhận liên kết mới.',
    demographics_load_error_subtitle: 'Vui lòng thử lại sau giây lát.',
    demographics_wrong_patient:
      'Biểu mẫu này thuộc về hồ sơ của bệnh nhân khác - vui lòng liên hệ với nhà cung cấp của bạn',
    demographics_minor_adding_for: 'Thêm trẻ cho {{name}}',
    demographics_minor_existing_children: 'Trẻ đã có trong hồ sơ của bạn',

    // Medical History
    mh_medications_no_update: 'Không, tôi cần cập nhật thuốc của mình',
    mh_conditions_no_update: 'Không, tôi cần cập nhật tình trạng sức khỏe của mình',
    mh_surgical_no_update: 'Không, tôi cần cập nhật tiền sử phẫu thuật của mình',
    mh_medications_confirm_question: 'Thông tin về thuốc này có chính xác và đầy đủ không?',
    mh_conditions_confirm_question: 'Thông tin về tình trạng sức khỏe này có chính xác và đầy đủ không?',
    mh_surgical_confirm_question: 'Thông tin về tiền sử phẫu thuật này có chính xác và đầy đủ không?',
    mh_conditions_none_label: 'Tôi không có bất kỳ tình trạng sức khỏe nào',
    mh_none_fallback_label: 'Không có mục nào được chọn',
    mh_allergies_skip: 'Tôi không có bất kỳ dị ứng nào',
    mh_minor_allergies_skip: 'Người chưa thành niên không có bất kỳ dị ứng nào',

    // Lab document
    lab_document_ready_title: 'Tài liệu phòng thí nghiệm của bạn đã sẵn sàng',
    lab_document_open: 'Mở tài liệu',
    lab_document_save: 'Lưu PDF',
    lab_document_expired_title: 'Liên kết này đã hết hạn',
    lab_document_expired_subtitle: 'Liên hệ với nhà cung cấp của bạn để nhận liên kết mới.',
    lab_document_missing_title: 'Không tìm thấy tài liệu',
    lab_document_missing_subtitle: 'Kiểm tra liên kết trong tin nhắn của bạn hoặc liên hệ với nhà cung cấp của bạn.',
    lab_document_error_title: 'Không thể tải tài liệu của bạn',
    lab_document_error_subtitle: 'Vui lòng thử lại sau.',

    // Lab visit booking
    lab_visit_ordered_by: 'Xét nghiệm do BS. {{name}} chỉ định',
    lab_visit_ordered_by_care_team: 'Xét nghiệm do nhóm chăm sóc của bạn chỉ định',
    lab_visit_title_choose_location: 'Phòng xét nghiệm gần bạn',
    lab_visit_title_your_visit: 'Lịch xét nghiệm của bạn',
    lab_visit_title_walk_in: 'Đến trực tiếp - bất kỳ ngày nào',
    lab_visit_fasting_title: 'Lần xét nghiệm này cần nhịn ăn',
    lab_visit_requisition_link: 'Cần phiếu xét nghiệm bản giấy? Tải PDF',
    lab_visit_retry: 'Thử lại',
    lab_visit_not_found_title: 'Không tìm thấy liên kết',
    lab_visit_not_found_subtitle: 'Hãy kiểm tra liên kết trong tin nhắn hoặc liên hệ nhóm chăm sóc của bạn.',
    lab_visit_expired_title: 'Liên kết này đã hết hạn',
    lab_visit_expired_subtitle: 'Hãy nhắn cho nhóm chăm sóc của bạn để nhận liên kết mới.',
    lab_visit_expired_sms: 'Nhắn cho nhóm chăm sóc',
    lab_visit_rate_limited_title: 'Chờ một chút...',
    lab_visit_rate_limited_subtitle: 'Vui lòng đợi vài giây rồi thử lại.',
    lab_visit_searching_near: 'Tìm quanh',
    lab_visit_find_locations: 'Tìm địa điểm',
    lab_visit_zip_hint: 'Tuần này bạn ở nơi khác? Hãy đổi mã ZIP - gần nơi làm việc cũng được.',
    lab_visit_location_distance: '{{miles}} mi',
    lab_visit_location_site_code: 'Địa điểm {{code}}',
    lab_visit_book_a_time: 'Chọn giờ hẹn',
    lab_visit_just_walk_in: 'Đến trực tiếp',
    lab_visit_show_more: 'Xem thêm (còn {{count}} gần đây)',
    lab_visit_locations_empty: 'Không có địa điểm Quest nào cho mã ZIP đó. Hãy thử một mã lân cận.',
    lab_visit_locations_error: 'Chúng tôi không tải được danh sách địa điểm. Vui lòng thử lại.',
    lab_visit_slots_title: 'Giờ nào phù hợp với bạn?',
    lab_visit_all_locations: 'Tất cả địa điểm',
    lab_visit_slot_first: 'Sớm nhất',
    lab_visit_slots_empty: 'Địa điểm này không còn giờ trống. Hãy thử địa điểm khác.',
    lab_visit_slots_error: 'Chúng tôi không tải được giờ trống của địa điểm này. Vui lòng thử lại.',
    lab_visit_slot_taken: 'Giờ đó vừa có người đặt - đây là các lựa chọn hiện tại.',
    lab_visit_book_error: 'Chúng tôi không đặt được giờ đó. Vui lòng thử lại.',
    lab_visit_booked_eyebrow: 'Đã xong',
    lab_visit_booked_when: '{{date}} lúc {{time}}',
    lab_visit_confirmation_code: 'Mã xác nhận {{code}}',
    lab_visit_confirmation_hint: 'Quầy tiếp nhận có thể tra cứu bạn bằng mã này.',
    lab_visit_bring_photo_id: 'Giấy tờ có ảnh - giấy phép lái xe là được',
    lab_visit_bring_empty_stomach: 'Bụng rỗng',
    lab_visit_bring_nothing_else: 'Vậy là xong - không cần giấy tờ gì, chỉ định của bạn đã có trong hệ thống của họ',
    lab_visit_show_check_in_card: 'Xem thẻ đăng ký của tôi',
    lab_visit_change_time: 'Đổi giờ',
    lab_visit_keep_current_time: 'Giữ giờ hiện tại',
    lab_visit_cancel_visit: 'Hủy lịch hẹn',
    lab_visit_cancel_confirm_title: 'Hủy lịch hẹn này?',
    lab_visit_cancel_confirm_description:
      'Bạn có chắc muốn hủy giờ hẹn đã đặt không? Sau khi xác nhận, bạn có thể chọn giờ khác',
    lab_visit_cancel_confirm_keep: 'Giữ lại',
    lab_visit_cancel_error: 'Chúng tôi không hủy được lịch hẹn của bạn. Vui lòng thử lại.',
    lab_visit_walk_in_intro:
      'Chỉ định của bạn đã có trong hệ thống của Quest. Hãy đến bất cứ khi nào địa điểm mở cửa - không cần hẹn trước.',
    lab_visit_walk_in_pick_label: 'Bạn đã chọn',
    lab_visit_walk_in_any_location: 'Bất kỳ địa điểm Quest nào',
    lab_visit_walk_in_bring_label: 'Hãy mang theo',
    lab_visit_bring_photo_id_label: 'Giấy tờ có ảnh',
    lab_visit_bring_photo_id_detail: 'Quest chỉ cần có vậy',
    lab_visit_bring_stomach_water: 'Uống nước thì được; đừng ăn sáng hôm đó',
    lab_visit_bring_stomach_nothing: 'Không ăn hay uống gì trước khi đến',
    lab_visit_book_a_time_instead: 'Chọn giờ hẹn thay vì vậy',
    lab_visit_walk_in_error: 'Chúng tôi không lưu được lựa chọn đến trực tiếp. Vui lòng thử lại.',
    lab_visit_walk_in_switch_error: 'Chúng tôi không chuyển sang đặt hẹn được. Vui lòng thử lại.',
    lab_visit_check_in_title: 'Xuất trình thẻ này tại quầy',
    lab_visit_check_in_patient: 'Bệnh nhân',
    lab_visit_check_in_dob: 'Ngày sinh',
    lab_visit_check_in_requisition: 'Phiếu xét nghiệm',
    lab_visit_check_in_confirmation: 'Mã xác nhận',
    lab_visit_check_in_you_owe: 'Bạn phải trả',
    lab_visit_check_in_error: 'Chúng tôi không tải được thẻ đăng ký của bạn. Vui lòng thử lại.',
    lab_visit_degraded_eyebrow: 'Đặt hẹn trực tuyến đang không hoạt động',
    lab_visit_degraded_intro: 'Hệ thống đặt hẹn của Quest không phản hồi. Thường sẽ hoạt động lại trong vòng một giờ.',
    lab_visit_degraded_good_news:
      '<strong>Tin tốt:</strong> bạn không cần hẹn trước. Chỉ định của bạn đã có trong hệ thống của họ - bạn có thể đến bất cứ lúc nào họ mở cửa.',
    lab_visit_degraded_find_quest: 'Tìm một địa điểm Quest',
    lab_visit_degraded_bring_slip: 'Hãy mang theo phiếu xét nghiệm của bạn.',
    lab_visit_walk_in_instead: 'Đến trực tiếp thay vì vậy',
    lab_visit_try_booking_again: 'Thử đặt hẹn lại',
    lab_visit_upstream_down_notice:
      'Hệ thống đặt hẹn của Quest không phản hồi, nên hiện chưa thể đổi hoặc hủy lịch hẹn này. Vui lòng thử lại sau vài phút.',
    lab_visit_error_title: 'Chúng tôi không tải được lịch xét nghiệm của bạn',
    lab_visit_error_subtitle: 'Vui lòng thử lại sau.',

    // Visits & notes
    menu_visits_notes: 'Lượt khám & ghi chú',
    visits_notes_title: 'Lượt khám & ghi chú',
    visits_notes_load_more: 'Tải thêm',
    visits_notes_practitioner: 'BS. {{name}}',
    visits_notes_medications_prescribed_other: '{{count}} thuốc được kê',
    visits_notes_lab_order: 'Xét nghiệm máu',
    visits_notes_filter_all: 'Tất cả',
    visits_notes_filter_visits: 'Lượt khám',
    visits_notes_filter_notes: 'Giấy nghỉ học & nghỉ làm',
    visits_notes_filter_tests: 'Xét nghiệm',
    visits_notes_empty_notes: 'Không có giấy nghỉ học hay nghỉ làm để hiển thị từ các lượt khám đã tải',
    visits_notes_empty_tests: 'Không có xét nghiệm để hiển thị từ các lượt khám đã tải',
    visits_notes_error_title: 'Chúng tôi không tải được các lượt khám của bạn',
    visits_notes_error_subtitle: 'Vui lòng thử lại sau.',

    // Lab results
    menu_savings: 'Tiết kiệm',
    savings_title: 'Khoản tiết kiệm của bạn',
    savings_subtitle: 'Thêm một chút dư dả cho những điều quan trọng.',
    savings_scope_me: 'Tôi',
    savings_scope_household: 'Gia đình',
    savings_period_option_all_time: 'Toàn bộ thời gian',
    savings_period_option_this_month: 'Tháng này',
    savings_period_option_last_month: 'Tháng trước',
    savings_period_option_this_year: 'Năm nay',
    savings_period_option_last_year: 'Năm ngoái',
    savings_period_option_custom: 'Khoảng thời gian tùy chọn',
    savings_period_all_time: 'từ trước đến nay',
    savings_period_this_month: 'trong tháng này',
    savings_period_last_month: 'trong tháng trước',
    savings_period_this_year: 'trong năm nay',
    savings_period_last_year: 'trong năm ngoái',
    savings_period_custom: '{{from}} – {{to}}',
    savings_total_eyebrow: 'Giá trị hằng ngày của bạn',
    savings_total_period: 'Khoản tiết kiệm ước tính {{period}}',
    savings_total_period_empty: 'Khoản tiết kiệm đã ghi nhận {{period}}',
    savings_empty_title: 'Chưa ghi nhận khoản tiết kiệm nào',
    savings_empty_subtitle:
      'Sau khi bạn sử dụng Tap, mọi khoản tiết kiệm từ chăm sóc, đơn thuốc, xét nghiệm và quản lý cân nặng sẽ tự động hiển thị tại đây.',
    savings_category_prescriptions: 'Tiết kiệm đơn thuốc',
    savings_category_care: 'Tiết kiệm chăm sóc',
    savings_category_labs: 'Tiết kiệm xét nghiệm',
    savings_category_weight_program: 'Tiết kiệm quản lý cân nặng',
    savings_category_workdays: 'Ngày làm việc lấy lại được',
    savings_count_prescriptions: '{{count}} loại thuốc',
    savings_count_care: '{{count}} lượt khám',
    savings_count_labs: '{{count}} xét nghiệm',
    savings_count_weight_program: '{{count}} tháng phí chương trình',
    savings_count_workdays_other: '{{days}} ngày',
    savings_error_savings_disabled_title: 'Tính năng tiết kiệm hiện không khả dụng',
    savings_error_savings_disabled_subtitle: 'Vui lòng quay lại sau.',
    savings_error_not_found_title: 'Chúng tôi không tìm thấy khoản tiết kiệm cho bệnh nhân này',
    savings_error_not_found_subtitle: 'Hãy thử chọn một bệnh nhân khác.',
    savings_error_invalid_period_title: 'Khoảng thời gian không hợp lệ',
    savings_error_invalid_period_subtitle: 'Hãy chọn ngày bắt đầu trước hoặc bằng ngày kết thúc.',
    savings_error_unknown_title: 'Chúng tôi không thể tải khoản tiết kiệm của bạn',
    savings_error_unknown_subtitle: 'Vui lòng thử lại sau.',
    savings_drawer_close: 'Đóng',
    savings_drawer_total_prescriptions: 'Tổng tiết kiệm cho {{count}} loại thuốc',
    savings_drawer_total_care: 'Tổng tiết kiệm cho {{count}} lượt khám',
    savings_drawer_total_labs: 'Tổng tiết kiệm cho {{count}} xét nghiệm',
    savings_drawer_total_weight_program: 'Tổng tiết kiệm cho {{count}} tháng tham gia chương trình cân nặng',
    savings_drawer_total_workdays_other: 'Tổng tiết kiệm cho {{days}} ngày làm việc lấy lại được',
    savings_drawer_retail_price: 'Giá bán lẻ',
    savings_drawer_you_paid: 'Bạn đã trả',
    savings_drawer_estimated_expenses: 'Chi phí cá nhân ước tính',
    savings_breakdown_title: 'Chi tiết khoản tiết kiệm',
    savings_breakdown_empty: 'Không có khoản tiết kiệm nào được ghi nhận trong khoảng thời gian này.',
    savings_column_date: 'Ngày',
    savings_column_patient: 'Bệnh nhân',
    savings_column_medication: 'Thuốc',
    savings_column_retail_estimate: 'Giá bán lẻ ước tính',
    savings_column_coupon_price: 'Giá có phiếu giảm giá',
    savings_column_insurance_price: 'Giá ước tính qua bảo hiểm',
    savings_column_price_used: 'Giá được dùng',
    savings_column_savings: 'Tiết kiệm',
    savings_column_care_option: 'Lựa chọn chăm sóc khác',
    savings_column_estimated_expenses: 'Chi phí cá nhân ước tính',
    savings_column_lab_test: 'Xét nghiệm',
    savings_column_program: 'Chương trình',
    savings_column_workdays: 'Ngày làm việc lấy lại được',
    savings_column_workday_value: 'Giá trị ước tính mỗi ngày làm việc',
    savings_care_option_no_medical_care: '911, xe cứu thương và phòng cấp cứu',
    savings_care_option_no_care_options: 'Khám tại phòng cấp cứu',
    savings_care_option_urgent_care: 'Khám tại cơ sở chăm sóc khẩn cấp',
    savings_care_option_doctor_quick: 'Khám bác sĩ chăm sóc ban đầu',
    savings_care_option_waited_out: 'Chờ cho tự khỏi',
    savings_workdays_value_other: '{{days}} ngày làm việc',
    savings_explainer_title: 'Cách chúng tôi ước tính khoản tiết kiệm của bạn',
    savings_explainer_intro:
      'Chi phí chăm sóc, đơn thuốc và thời gian nghỉ làm có thể cộng dồn. Đây là cách chúng tôi ước tính giá trị bạn nhận được từ Tap, dựa trên hồ sơ chăm sóc, câu trả lời khảo sát và so sánh giá của bạn.',
    savings_explainer_prescriptions_title: 'Tiết kiệm đơn thuốc',
    savings_explainer_prescriptions_p1:
      'Chúng tôi so sánh giá bán lẻ ước tính của thuốc với giá tương đương thấp nhất hiện có khi dùng phiếu giảm giá hoặc bảo hiểm. Khoản tiết kiệm tiềm năng lớn nhất được cộng vào tổng của bạn.',
    savings_explainer_prescriptions_p2:
      'Giá cuối cùng tại nhà thuốc có thể khác. Việc biết bạn đã nhận thuốc không cho chúng tôi biết bạn đã trả bao nhiêu, nên đây vẫn chỉ là ước tính.',
    savings_explainer_prescriptions_p3:
      'Dựa trên giá bán lẻ và giá có phiếu giảm giá từ báo cáo phiếu giảm giá của DoseSpot, cùng ước tính bảo hiểm từ thông tin quyền lợi đơn thuốc theo thời gian thực của DoseSpot.',
    savings_explainer_care_title: 'Tiết kiệm chăm sóc',
    savings_explainer_care_p1:
      'Trong khảo sát, bạn cho chúng tôi biết bạn sẽ đi đâu nếu không có Tap. Chúng tôi dùng chi phí ước tính thông thường của lựa chọn chăm sóc đó để tính số tiền bạn có thể đã phải chi.',
    savings_explainer_care_p2:
      'Nếu bạn chọn “chờ cho tự khỏi”, lượt khám đó không được cộng thêm vào khoản tiết kiệm. Nếu bạn không trả lời, chúng tôi không tính lượt khám đó.',
    savings_explainer_care_p3:
      'Dựa trên câu trả lời khảo sát của bạn và mức ước tính cố định của Tap cho từng lựa chọn chăm sóc.',
    savings_explainer_labs_title: 'Tiết kiệm xét nghiệm',
    savings_explainer_labs_p1:
      'Với mỗi chỉ định xét nghiệm miễn phí, chúng tôi cộng một khoản tiết kiệm ước tính cố định khi tất cả kết quả của bạn đã có.',
    savings_explainer_labs_p2:
      'Mỗi chỉ định chỉ được tính một lần, dù gồm một xét nghiệm hay nhiều xét nghiệm và nhóm xét nghiệm.',
    savings_explainer_labs_p3:
      'Dựa trên các chỉ định xét nghiệm đã hoàn tất trong hồ sơ của bạn và mức ước tính cố định của Tap cho mỗi chỉ định.',
    savings_explainer_weight_program_title: 'Tiết kiệm quản lý cân nặng',
    savings_explainer_weight_program_p1:
      'Chúng tôi cộng một khoản tiết kiệm ước tính cố định cho mỗi tháng dương lịch bạn tham gia chương trình quản lý cân nặng sau khi bắt đầu điều trị.',
    savings_explainer_weight_program_p2:
      'Một tháng chưa trọn vẫn được tính là một tháng. Mỗi tháng chỉ được tính một lần, kể cả khi các giai đoạn tham gia trùng nhau. Khoản tiết kiệm về thuốc được tính trong tiết kiệm đơn thuốc.',
    savings_explainer_weight_program_p3:
      'Dựa trên ngày điều trị của bạn và mức phí chương trình hằng tháng để so sánh.',
    savings_explainer_workdays_title: 'Ngày làm việc lấy lại được',
    savings_explainer_workdays_p1:
      'Khảo sát cho chúng tôi biết bạn đã lấy lại được bao nhiêu thời gian làm việc. Chúng tôi tính câu trả lời của bạn là nửa ngày, 1, 2 hoặc 3 ngày, rồi nhân với một giá trị cố định cho mỗi ngày làm việc.',
    savings_explainer_workdays_p2:
      'Nếu bạn lấy lại được thời gian khi chăm sóc con, những ngày đó được ghi nhận cho bạn với tư cách là cha mẹ. Với một lượt khám chung, chúng tôi dùng số ngày cao nhất được báo cáo và chỉ tính một lần.',
    savings_explainer_workdays_p3:
      'Đây là ước tính giá trị thời gian của bạn, không phải thu nhập hay tiền đã nhận được xác nhận.',
    savings_explainer_workdays_p4:
      'Dựa trên câu trả lời khảo sát của bạn. Giá trị mỗi ngày lấy từ thu nhập trung vị hằng tuần của Cục Thống kê Lao động Hoa Kỳ, chia cho năm ngày làm việc.',
    menu_lab_results: 'Kết quả xét nghiệm',
    lab_results_title: 'Kết quả xét nghiệm',
    lab_results_subtitle:
      'Tất cả chỉ định do bạn hoặc bác sĩ của bạn đặt, mới nhất trước. Mở một chỉ định để xem các xét nghiệm.',
    lab_results_order_number: 'Chỉ định số {{number}}',
    lab_results_kind_panel: 'Gói xét nghiệm',
    lab_results_kind_individual_tests: 'Xét nghiệm riêng lẻ',
    lab_results_kind_mixed: 'Gói + xét nghiệm',
    lab_results_ordered_by: 'Được chỉ định bởi BS. {{name}}',
    lab_results_ordered_by_you: 'Do bạn đặt',
    lab_results_ordered_by_care_team: 'Do nhóm chăm sóc của bạn đặt',
    lab_results_released_on: 'Công bố ngày {{date}}',
    lab_results_status_awaiting_visit: 'Chờ lấy mẫu',
    lab_results_status_scheduled: 'Đã đặt lịch hẹn',
    lab_results_status_processing: 'Đang chờ kết quả',
    lab_results_status_results_ready: 'Đã có kết quả',
    lab_results_status_rejected: 'Không thể xử lý',
    lab_results_status_cancelled: 'Đã hủy',
    lab_results_status_expired: 'Đã hết hạn',
    lab_results_status_failed: 'Không thể hoàn tất',
    lab_results_badge_needs_attention: '{{count}} cần chú ý',
    lab_results_badge_worth_a_look: '{{count}} nên xem lại',
    lab_results_badge_in_range: 'Trong ngưỡng',
    lab_results_empty:
      'Chưa có kết quả xét nghiệm. Khi bác sĩ chỉ định xét nghiệm cho bạn, kết quả sẽ xuất hiện ở đây.',
    lab_results_error_title: 'Chúng tôi không tải được kết quả xét nghiệm của bạn',
    lab_results_error_subtitle: 'Vui lòng thử lại sau.',

    // Lab results - order details
    lab_results_order_not_found_title: 'Chúng tôi không tìm thấy chỉ định này',
    lab_results_order_not_found_subtitle:
      'Chỉ định này có thể thuộc về bệnh nhân khác, hoặc kết quả chưa được công bố.',
    lab_results_biomarker_count_other: '{{count}} chỉ số',
    lab_results_test_count_other: '{{count}} xét nghiệm',
    lab_results_group_in_range: 'Trong ngưỡng',
    lab_results_group_worth_a_look: 'Nên xem lại',
    lab_results_group_other: 'Khác',
    lab_results_group_needs_attention: 'Cần chú ý',
    lab_results_test_status_pending: 'Đang chờ',
    lab_results_test_status_final: 'Đã nhận kết quả',
    lab_results_test_status_corrected: 'Đã hiệu chỉnh',
    lab_results_test_status_not_performed: 'Không thực hiện',
    lab_results_update_pending:
      'Phòng xét nghiệm đã hiệu chỉnh một trong các kết quả này và bác sĩ của bạn đang xem lại thay đổi. Nội dung bạn thấy ở đây có thể được cập nhật.',
    lab_results_report_download: 'Tải xuống (PDF)',
    lab_results_report_filename: 'lab-report-{{number}}.pdf',
    lab_results_report_error: 'Chúng tôi không tải được báo cáo của bạn. Vui lòng thử lại.',
    lab_results_note_title: 'Ghi chú của bác sĩ',
    lab_results_note_author: 'BS. {{name}}',
    lab_results_note_empty: 'Không có ghi chú. Bác sĩ của bạn đã xem các kết quả này và công bố mà không có nhận xét.',
    lab_results_chip_all: 'Tất cả ({{count}})',
    lab_results_filter_empty: 'Không có kết quả nào khớp với bộ lọc đã chọn.',
    lab_results_attention_eyebrow: 'Cần chú ý ngay',
    lab_results_attention_title_single: 'Một kết quả cần được chăm sóc ngay',
    lab_results_attention_title_multiple: '{{count}} kết quả cần được chăm sóc ngay',
    lab_results_attention_reference: '(ngưỡng tham chiếu của phòng xét nghiệm {{reference}})',
    lab_results_attention_eyebrow_soon: 'Hãy liên hệ bác sĩ sớm',
    lab_results_attention_title_single_soon: 'Một kết quả cần được chú ý sớm',
    lab_results_attention_title_multiple_soon: '{{count}} kết quả cần được chú ý sớm',
    lab_results_attention_no_guide:
      'Phòng xét nghiệm đã đánh dấu kết quả này là nguy cấp. Bác sĩ của bạn sẽ liên hệ với bạn.',
    lab_safety_net_emergency: 'Gọi 911 hoặc đến phòng cấp cứu nếu',
    lab_safety_net_same_day: 'Hãy đi khám bác sĩ ngay hôm nay nếu',
    lab_results_text_doctor: 'Nhắn tin cho bác sĩ Tap',
    lab_results_attention_hours:
      'Tin nhắn Tap từ 7 giờ sáng đến 10 giờ tối. Nhắn tin không thay thế việc chăm sóc y tế ngay lập tức.',
    lab_results_ask_doctor_note:
      'Bạn có thắc mắc về chỉ định này? Bác sĩ của bạn xem kết quả này ngay cạnh tin nhắn của bạn.',
    lab_results_ask_doctor_cta: 'Hỏi bác sĩ Tap',
    lab_results_state_waiting_title: 'Đang chờ kết quả',
    lab_results_state_waiting_body:
      'Mẫu của bạn chưa đến phòng xét nghiệm. Phần lớn kết quả có trong 2-3 ngày sau khi lấy mẫu; chúng tôi sẽ nhắn tin cho bạn khi có kết quả.',
    lab_results_state_processing_title: 'Đang chờ kết quả',
    lab_results_state_processing_body:
      'Mẫu của bạn đang ở phòng xét nghiệm. Phần lớn kết quả có trong 2-3 ngày sau khi lấy mẫu; chúng tôi sẽ nhắn tin cho bạn khi có kết quả.',
    lab_results_state_partial_title: 'Một số kết quả đang trên đường về',
    lab_results_state_partial_body:
      'Một số kết quả của bạn đã về và phần còn lại vẫn đang ở phòng xét nghiệm. Chúng tôi sẽ nhắn tin cho bạn khi có đủ kết quả.',
    lab_results_state_rejected_title: 'Không thể xử lý chỉ định này',
    lab_results_state_rejected_body:
      'Phòng xét nghiệm không thể tiếp nhận chỉ định này. Bác sĩ của bạn sẽ liên hệ với bạn.',
    lab_results_state_cancelled_title: 'Chỉ định này đã bị hủy',
    lab_results_state_cancelled_body: 'Chỉ định này sẽ không có kết quả.',
    lab_results_state_expired_title: 'Chỉ định này đã hết hạn',
    lab_results_state_expired_body:
      'Không có mẫu nào được lấy kịp thời. Bác sĩ của bạn có thể chỉ định lại các xét nghiệm này.',
    lab_results_state_failed_title: 'Không thể hoàn tất chỉ định này',
    lab_results_state_failed_body: 'Chỉ định này sẽ không có kết quả. Bác sĩ của bạn sẽ liên hệ với bạn.',

    // Lab results - biomarker details
    lab_marker_not_found_title: 'Chúng tôi không tìm thấy kết quả này',
    lab_marker_not_found_subtitle: 'Kết quả này có thể thuộc về bệnh nhân khác, hoặc chưa được công bố.',
    lab_marker_result: 'Kết quả của bạn',
    lab_marker_result_on: 'Kết quả của bạn · {{date}}',
    lab_marker_reference_caption:
      'Ngưỡng tham chiếu của phòng xét nghiệm {{reference}}. Ngưỡng này lấy từ báo cáo này. Đây không phải là ngưỡng cấp cứu hay nguy hiểm.',
    lab_marker_reference_plain: 'Ngưỡng tham chiếu của phòng xét nghiệm {{reference}}',
    lab_marker_meaning_title: 'Kết quả của bạn có nghĩa là gì',
    lab_marker_next_step_title: 'Tôi nên làm gì tiếp theo?',
    lab_marker_why_this_matters: 'Vì sao điều này quan trọng',
    lab_marker_ask_doctor_note:
      'Bạn có câu hỏi về kết quả này? Bác sĩ của bạn xem kết quả này bên cạnh tin nhắn của bạn.',
    lab_marker_content_pending: 'Các bác sĩ Tap đang xem xét phần giải thích cho kết quả này.',
    lab_marker_action_eyebrow: 'Hãy hành động ngay',
    lab_marker_variants_title: 'Điều nào sau đây đúng với bạn?',
    lab_marker_variants_subtitle:
      'Chọn một mục và phần giải thích bên dưới sẽ được viết lại cho tình huống đó. Kết quả của bạn không thay đổi.',
    lab_marker_variants_adjusted: 'Phần giải thích đã điều chỉnh cho: {{label}}',
    lab_marker_variant_female_pregnant: 'Tôi đang mang thai',
    lab_marker_variant_postmenopausal: 'Sau mãn kinh',

    // Lab results - order history
    lab_results_history_title: 'Lịch sử chỉ định',
    lab_results_history_progress: '{{done}} trong {{total}} bước',
    lab_results_history_ordered: 'Đã đặt chỉ định',
    lab_results_history_ordered_by: 'Được chỉ định bởi BS. {{name}}',
    lab_results_history_ordered_by_you: 'Do bạn đặt',
    lab_results_history_ordered_by_care_team: 'Do nhóm chăm sóc của bạn đặt',
    lab_results_history_ordered_detail_add_ons_other: '{{panels}} + {{count}} xét nghiệm bổ sung',
    lab_results_history_sent_to_lab: 'Đã gửi tới Quest Diagnostics',
    lab_results_history_sent_detail: 'Phiếu xét nghiệm đã sẵn sàng, không cần nhịn ăn',
    lab_results_history_sent_detail_fasting: 'Phiếu xét nghiệm đã sẵn sàng, cần nhịn ăn',
    lab_results_history_visit_scheduled: 'Đã đặt lịch hẹn',
    lab_results_history_visit_scheduled_next: 'Đặt lịch hẹn',
    lab_results_history_visit_detail_next:
      'Chọn địa điểm Quest và thời gian, hoặc đến trực tiếp vào bất kỳ buổi sáng nào',
    lab_results_history_sample_collected: 'Đã lấy mẫu',
    lab_results_history_collected_walk_in: 'Đến trực tiếp tại {{location}}',
    lab_results_history_collected_at: 'Lấy mẫu tại {{location}}',
    lab_results_history_results_partial: 'Đã có một số kết quả',
    lab_results_history_results_partial_detail: '{{resulted}} trong {{total}} xét nghiệm đã có kết quả',
    lab_results_history_results_final: 'Đã có tất cả kết quả',
    lab_results_history_results_final_next: 'Kết quả',
    lab_results_history_results_final_detail: '{{tests}}, {{biomarkers}}',
    lab_results_history_results_final_detail_next:
      'Thường là 2-3 ngày sau khi lấy mẫu. Chúng tôi sẽ nhắn tin cho bạn khi có kết quả',
    lab_results_history_provider_review: 'Đã được bác sĩ của bạn xem',
    lab_results_history_reviewed_by: 'Được BS. {{name}} xem',
    lab_results_history_provider_review_next: 'Bác sĩ xem xét',
    lab_results_history_provider_review_detail: 'Không cần làm gì thêm',
    lab_results_history_results_released: 'Đã công bố cho bạn',
    lab_results_history_results_released_next: 'Đã công bố kết quả',
    lab_results_history_results_released_detail: 'Đã gửi tin nhắn',

    // Free labs signup
    free_labs_eyebrow: 'Xét nghiệm miễn phí · Tap chi trả · Bạn trả $0',
    free_labs_community: 'Cộng đồng: {{name}}',
    free_labs_community_batavia: 'Batavia, IL',
    free_labs_community_aurora: 'Aurora, IL',
    free_labs_community_rolling_meadows: 'Rolling Meadows, IL',
    free_labs_title_phone: 'Xét nghiệm miễn phí cho cư dân',
    free_labs_title_code: 'Nhập mã chúng tôi đã gửi qua tin nhắn',
    free_labs_title_picker: 'Hôm nay ai đặt xét nghiệm?',
    free_labs_title_form_new: 'Hãy cho chúng tôi biết về bạn',
    free_labs_title_form_returning: 'Chào mừng trở lại, {{name}}',
    free_labs_session_expired: 'Phiên của bạn đã hết hạn. Hãy xác minh lại số điện thoại di động để tiếp tục.',
    free_labs_unavailable_title: 'Xét nghiệm miễn phí hiện không khả dụng',
    free_labs_unavailable_subtitle: 'Vui lòng thử lại sau.',
    free_labs_error_generic: 'Đã xảy ra lỗi. Vui lòng thử lại.',
    free_labs_error_rate_limited: 'Quá nhiều lần thử. Vui lòng đợi vài phút rồi thử lại.',
    free_labs_error_send_failed: 'Chúng tôi không gửi được mã. Vui lòng thử lại.',
    free_labs_phone_intro:
      'Bạn sắp đặt một gói xét nghiệm máu miễn phí. Phòng xét nghiệm yêu cầu số điện thoại di động đã xác minh trước khi chúng tôi có thể đặt. Chúng tôi sẽ gửi cho bạn mã 6 chữ số qua tin nhắn.',
    free_labs_phone_note: 'Mỗi người một gói. Bảo hiểm của bạn không ảnh hưởng đến điều kiện tham gia.',
    free_labs_phone_label: 'Số điện thoại di động',
    free_labs_phone_required: 'Nhập số điện thoại di động của bạn',
    free_labs_phone_invalid: 'Nhập số điện thoại di động hợp lệ tại Hoa Kỳ',
    free_labs_phone_cta: 'Gửi mã cho tôi',
    free_labs_phone_footer: 'Có thể áp dụng cước tin nhắn. Liên kết đặt lịch và kết quả sẽ được gửi đến số này.',
    free_labs_code_sent_to: 'Đã gửi đến <strong>{{phone}}</strong>.',
    free_labs_code_change_number: 'Đổi số',
    free_labs_code_cta: 'Xác minh',
    free_labs_code_resend_prompt: 'Chưa nhận được?',
    free_labs_code_resend: 'Gửi lại mã',
    free_labs_code_resent: 'Chúng tôi đã gửi cho bạn mã mới.',
    free_labs_code_invalid: 'Mã đó không đúng. Kiểm tra tin nhắn và thử lại.',
    free_labs_code_expired: 'Mã đó đã hết hạn. Hãy yêu cầu mã mới.',
    free_labs_picker_intro:
      'Có nhiều hơn một người trưởng thành trong hộ gia đình của bạn dùng số này. Hãy chọn chính bạn để chúng tôi điền sẵn thông tin.',
    free_labs_picker_born: 'Sinh năm {{year}}',
    free_labs_picker_unnamed: 'Thành viên hộ gia đình',
    free_labs_picker_order_placed: 'Đã đặt',
    free_labs_picker_footnote:
      'Không có trong danh sách? Một số điện thoại đã biết chỉ có thể đăng ký cho những người trưởng thành đã đăng ký trên đó. Hãy dùng số điện thoại di động của chính bạn.',
    free_labs_picker_cta: 'Tiếp tục',
    free_labs_picker_not_on_phone:
      'Chúng tôi không tải được thông tin của người đó. Hãy chọn lại hoặc dùng số điện thoại di động của chính bạn.',
    free_labs_last_request_title: 'Yêu cầu của bạn ngày {{date}} đã không thành công',
    free_labs_last_request_outside_city:
      'Địa chỉ nằm ngoài ranh giới thành phố của chương trình. Nếu bạn đã chuyển nhà hoặc địa chỉ bị sai, hãy cập nhật bên dưới và gửi lại.',
    free_labs_last_request_quota_full:
      'Khi đó tất cả gói miễn phí ở cộng đồng này đã hết. Bạn có thể gửi lại bên dưới.',
    free_labs_last_request_duplicate:
      'Một gói miễn phí đã được đặt cho người này. Hãy kiểm tra tin nhắn để tìm liên kết đặt lịch hoặc kết quả.',
    free_labs_last_request_address_unresolved:
      'Chúng tôi không định vị được địa chỉ trên bản đồ. Hãy chọn từ các gợi ý bên dưới và gửi lại.',
    free_labs_last_request_order_failed:
      'Phòng xét nghiệm không chấp nhận yêu cầu. Đội ngũ của chúng tôi đã được thông báo; bạn có thể gửi lại bên dưới.',
    free_labs_last_order_title: 'Yêu cầu của bạn ngày {{date}} không còn hiệu lực',
    free_labs_last_order_expired:
      'Phiếu xét nghiệm đã hết hạn trước khi lấy mẫu. Kiểm tra thông tin và gửi lại bên dưới.',
    free_labs_last_order_cancelled: 'Yêu cầu đã bị hủy. Kiểm tra thông tin và gửi lại bên dưới.',
    free_labs_last_order_rejected: 'Phòng xét nghiệm không chấp nhận yêu cầu. Kiểm tra thông tin và gửi lại bên dưới.',
    free_labs_last_order_failed: 'Phòng xét nghiệm không chấp nhận yêu cầu. Kiểm tra thông tin và gửi lại bên dưới.',
    free_labs_need_email_title: 'Chúng tôi cần email của bạn',
    free_labs_need_email_body:
      'Phòng xét nghiệm gửi hướng dẫn lấy mẫu qua email. Chúng tôi chưa có email hợp lệ của bạn.',
    free_labs_dob_hint: 'Bạn phải từ 18 tuổi trở lên.',
    free_labs_sex: 'Giới tính',
    free_labs_sex_hint: 'Phòng xét nghiệm yêu cầu để xác định khoảng tham chiếu.',
    free_labs_email_required: 'Email là bắt buộc',
    free_labs_email_taken: 'Email này thuộc về một bệnh nhân khác. Hãy dùng email khác.',
    free_labs_phone_taken: 'Số điện thoại này thuộc về một bệnh nhân khác. Vui lòng liên hệ với chúng tôi.',
    free_labs_phone_verified: 'Đã xác minh',
    free_labs_address: 'Địa chỉ nhà',
    free_labs_address_required: 'Chọn địa chỉ của bạn từ các gợi ý',
    free_labs_address_change: 'Thay đổi',
    free_labs_consents_legend: 'Vui lòng xác nhận',
    free_labs_consent_required: 'Vui lòng đánh dấu ô này để tiếp tục',
    free_labs_consent_attestation: 'Tôi từ 18 tuổi trở lên và sống tại địa chỉ ở trên.',
    free_labs_consent_sms:
      'Tap có thể nhắn tin cho tôi về yêu cầu xét nghiệm và kết quả. Có thể áp dụng cước tin nhắn. Trả lời STOP bất cứ lúc nào.',
    free_labs_consent_hipaa:
      'Tôi đồng ý với <telehealth>thỏa thuận khám bệnh từ xa</telehealth>, <terms>điều khoản sử dụng</terms> và <privacy>chính sách bảo mật</privacy>.',
    free_labs_form_not_on_phone: 'Người này chưa được đăng ký trên số điện thoại di động của bạn.',
    free_labs_submit_cta: 'Đặt xét nghiệm miễn phí',
    free_labs_ordered_title: 'Yêu cầu xét nghiệm miễn phí của bạn đã được đặt',
    free_labs_ordered_subtitle:
      'Kết quả sẽ được gửi qua tin nhắn, hoặc bác sĩ của Tap sẽ liên hệ để trao đổi với bạn. Chúng tôi cũng sẽ gửi liên kết đặt lịch đến <strong>{{phone}}</strong>.',
    free_labs_ordered_waiting_title: 'Đang chờ phòng xét nghiệm xác nhận yêu cầu…',
    free_labs_ordered_waiting_body:
      'Việc này thường chỉ mất một lúc. Bạn cũng có thể đóng trang này: liên kết đặt lịch sẽ được gửi qua tin nhắn.',
    free_labs_ordered_texted_title: 'Chúng tôi sẽ nhắn liên kết đặt lịch cho bạn',
    free_labs_ordered_texted_body:
      'Phòng xét nghiệm vẫn đang xác nhận yêu cầu. Ngay khi xong, liên kết đặt lịch sẽ được gửi qua tin nhắn.',
    free_labs_book_visit: 'Đặt lịch xét nghiệm',
    free_labs_book_visit_caption:
      'Cùng liên kết chúng tôi đã nhắn cho bạn. Kết quả sẽ được gửi qua tin nhắn hoặc bác sĩ của Tap sẽ liên hệ với bạn.',
    free_labs_already_title: 'Chào {{name}}, mọi thứ đã sẵn sàng',
    free_labs_already_title_unnamed: 'Mọi thứ đã sẵn sàng',
    free_labs_already_subtitle:
      'Chúng tôi đã đặt yêu cầu xét nghiệm miễn phí của bạn ngày {{date}}. Mỗi người một gói, nên không cần gửi thêm gì.',
    free_labs_already_book:
      'Cùng liên kết chúng tôi đã nhắn cho bạn. Kết quả sẽ được gửi qua tin nhắn hoặc bác sĩ của Tap sẽ liên hệ với bạn.',
    free_labs_already_awaiting_requisition:
      'Phòng xét nghiệm chưa phát hành phiếu xét nghiệm. Chúng tôi sẽ sớm nhắn liên kết đặt lịch cho bạn.',
    free_labs_already_results_pending: 'Đã lấy mẫu của bạn. Chúng tôi sẽ nhắn tin khi có kết quả.',
    free_labs_already_released: 'Kết quả đã được gửi qua tin nhắn. Hãy kiểm tra tin nhắn để tìm liên kết kết quả.',
    free_labs_declined_outside_city_title: 'Địa chỉ này nằm ngoài khu vực chương trình',
    free_labs_declined_outside_city_body:
      'Gói miễn phí dành cho cư dân trong ranh giới thành phố Batavia, Aurora hoặc Rolling Meadows. Địa chỉ bạn nhập nằm ngoài các khu vực đó. Nếu địa chỉ sai, hãy quay lại và chọn lại.',
    free_labs_declined_quota_full_title: 'Tất cả gói miễn phí trong khu vực của bạn đã hết',
    free_labs_declined_quota_full_title_named: 'Tất cả gói miễn phí cho {{name}} đã hết',
    free_labs_declined_quota_full_body:
      'Chương trình chỉ dành cho một số lượng cư dân giới hạn và đã đạt đến giới hạn đó. Chúng tôi đã lưu thông tin của bạn.',
    free_labs_declined_duplicate_title: 'Một gói miễn phí đã được đặt cho bạn',
    free_labs_declined_duplicate_body:
      'Mỗi người một gói, nên không cần gửi thêm gì. Hãy kiểm tra tin nhắn để tìm liên kết đặt lịch hoặc kết quả.',
    free_labs_declined_address_unresolved_title: 'Chúng tôi không định vị được địa chỉ của bạn trên bản đồ',
    free_labs_declined_address_unresolved_body:
      'Hãy chọn địa chỉ từ các gợi ý để chúng tôi kiểm tra địa chỉ có nằm trong khu vực chương trình không.',
    free_labs_declined_order_failed_title: 'Chúng tôi không đặt được yêu cầu của bạn',
    free_labs_declined_order_failed_body:
      'Đã xảy ra lỗi phía phòng xét nghiệm. Đội ngũ của chúng tôi đã được thông báo và sẽ nhắn tin đến {{phone}} để hoàn tất yêu cầu. Bạn không cần làm gì.',
    free_labs_fix_address: 'Sửa địa chỉ của tôi',

    // Weight program (Foundayo)
    menu_weight_program: 'Chương trình quản lý cân nặng',
    weight_program_brand: 'Chương trình cân nặng',

    weight_program_intro_title: 'Foundayo cho việc quản lý cân nặng',
    weight_program_intro_body:
      'Foundayo (orforglipron) là viên uống hằng ngày, dùng kèm kế hoạch ăn uống và vận động. Hãy trả lời 10 câu hỏi ngắn để bác sĩ Tap xem xét liệu thuốc có phù hợp với bạn không.',
    weight_program_intro_how_label: 'Cách thức hoạt động',
    weight_program_intro_how_value: '10 câu hỏi → bác sĩ xem xét → quyết định',
    weight_program_intro_takes_label: 'Thời gian',
    weight_program_intro_takes_value: 'Khoảng 5 phút',
    weight_program_intro_cost_label: 'Chi phí xem xét',
    weight_program_intro_cost_value: 'Đã bao gồm trong dịch vụ chăm sóc Tap của bạn',
    weight_program_intro_disclaimer:
      'Việc hoàn thành biểu mẫu không đảm bảo bạn sẽ được kê đơn. Bạn có thể chọn "Không chắc" khi cần trợ giúp. Chi phí thuốc và tình trạng sẵn có tại nhà thuốc sẽ được trao đổi với bác sĩ của bạn.',
    weight_program_intro_start: 'Bắt đầu',
    weight_program_intro_start_failed: 'Chúng tôi không thể bắt đầu chương trình. Vui lòng thử lại.',
    weight_program_how_title: 'Chương trình hoạt động như thế nào',
    weight_program_how_step_review:
      'Bác sĩ xem xét biểu mẫu ban đầu của bạn, xác nhận các số đo và tiền sử ăn uống, cùng bạn thống nhất mục tiêu sức khỏe và phê duyệt kế hoạch.',
    weight_program_how_step_first_dose:
      'Bạn xác nhận ngày uống viên thuốc đầu tiên, và sau đó là ngày bắt đầu mỗi liều mới. Bác sĩ có thể liên hệ với bạn sau 1–2 tuần kể từ khi bắt đầu hoặc thay đổi liều, hoặc sớm hơn nếu bạn có lo lắng.',
    weight_program_how_step_monthly:
      'Khoảng mỗi tháng một lần, bạn sẽ nhận được một biểu mẫu kiểm tra ngắn, kèm nhắc nhở nếu chưa hoàn thành.',
    weight_program_how_step_changes:
      'Bác sĩ xem xét mọi lần kiểm tra trước khi thay đổi đơn thuốc. Nếu bạn bỏ qua một câu hỏi, đội ngũ chăm sóc sẽ liên hệ lại.',
    weight_program_how_step_goal:
      'Khi đạt được mục tiêu, chúng ta sẽ trao đổi về việc duy trì. Nếu ngừng thuốc, bác sĩ sẽ thống nhất cách theo dõi và cách quay lại chăm sóc.',

    weight_program_consent_title: 'Trước khi bắt đầu',
    weight_program_consent_body_review:
      'Câu trả lời của bạn được lưu trong hồ sơ Tap và được bác sĩ Tap xem xét. Tap dùng công cụ AI để sắp xếp câu trả lời cho bác sĩ; AI không đưa ra quyết định điều trị. Bác sĩ của bạn quyết định về điều kiện tham gia, đơn thuốc và mọi thay đổi.',
    weight_program_consent_body_sms:
      'Kiểm tra hằng tháng là một phần của chương trình này. Khoảng mỗi tháng một lần, chúng tôi sẽ nhắn tin cho bạn đường dẫn đến một biểu mẫu ngắn, kèm nhắc nhở nếu chưa hoàn thành.',
    weight_program_consent_ai_and_doctor_review:
      'Tôi hiểu rằng bác sĩ xem xét câu trả lời của tôi và đưa ra mọi quyết định điều trị, còn AI chỉ được dùng để sắp xếp thông tin.',
    weight_program_consent_program_sms:
      'Tôi đồng ý nhận tin nhắn về chương trình này, bao gồm đường dẫn biểu mẫu kiểm tra hằng tháng và các nhắc nhở.',
    weight_program_consent_continue: 'Tiếp tục',
    weight_program_consent_accepted_on: 'Bạn đã đồng ý vào ngày {{date}}.',
    weight_program_consent_failed: 'Chúng tôi không thể lưu các chấp thuận của bạn. Vui lòng thử lại.',

    weight_program_submitted_title: 'Cảm ơn bạn. Câu trả lời của bạn đã được gửi tới bác sĩ.',
    weight_program_submitted_body:
      'Bác sĩ Tap sẽ xem xét và cho bạn biết bước tiếp theo. Biểu mẫu này không phê duyệt đơn thuốc.',
    weight_program_submitted_status_label: 'Trạng thái',
    weight_program_submitted_status_value: 'Đang chờ bác sĩ xem xét',
    weight_program_submitted_sent_label: 'Đã gửi',
    weight_program_submitted_answers_title: 'Câu trả lời của bạn',

    weight_program_eyebrow: 'Bắt đầu',
    weight_program_progress_label: 'Tiến độ của bạn',
    weight_program_question_counter: 'Câu hỏi {{current}} trên {{total}}',
    weight_program_review_title: 'Xem lại câu trả lời của bạn',
    weight_program_review_helper:
      'Bạn có thể quay lại và thay đổi bất kỳ điều gì trước khi gửi. Sau khi gửi, bác sĩ sẽ xem xét các câu trả lời này; mọi thay đổi thực hiện qua Trò chuyện.',
    weight_program_review_back: 'Quay lại câu hỏi',
    weight_program_submit: 'Gửi',
    weight_program_not_answered: 'Chưa trả lời',
    weight_program_height_label: 'Chiều cao của bạn',
    weight_program_weight_label: 'Cân nặng của bạn',
    weight_program_measured_on_label: 'Bạn đã đo khi nào?',
    weight_program_problem_missing: 'Vui lòng trả lời câu hỏi này trước khi tiếp tục.',
    weight_program_problem_choose_one: 'Vui lòng chọn một phương án.',
    weight_program_problem_exclusive_option: 'Phương án đó không thể kết hợp với các phương án khác.',
    weight_program_problem_measurements_incomplete: 'Vui lòng điền chiều cao, cân nặng và ngày đo.',
    weight_program_problem_measured_on_in_future: 'Ngày không thể ở tương lai.',
    weight_program_problem_detail_required: 'Vui lòng liệt kê thuốc và thực phẩm bổ sung của bạn.',
    weight_program_flag_title_emergency: 'Hãy tìm trợ giúp ngay',
    weight_program_flag_title_poison_control: 'Hãy gọi ngay cho Trung tâm Kiểm soát Chất độc: 1-800-222-1222.',
    weight_program_flag_title_same_day: 'Nhóm chăm sóc của bạn sẽ liên hệ với bạn trong hôm nay.',
    weight_program_problem_inconsistent: 'Số ngày liên tiếp không thể nhiều hơn tổng số ngày đã quên.',
    weight_program_save_failed: 'Chúng tôi không thể lưu câu trả lời của bạn. Vui lòng kiểm tra kết nối và thử lại.',
    weight_program_submit_failed: 'Chúng tôi không thể gửi câu trả lời của bạn. Vui lòng thử lại.',
    weight_program_load_failed: 'Chúng tôi không thể tải biểu mẫu của bạn. Vui lòng thử lại.',
    weight_program_option_yes: 'Có',
    weight_program_option_no: 'Không',
    weight_program_option_not_sure: 'Tôi không chắc',
    weight_program_option_none: 'Không có điều nào trong số này',
    weight_program_helper_choose_all: 'Chọn tất cả các mục phù hợp.',
    weight_program_body_measurements_title: 'Chiều cao và cân nặng của bạn là bao nhiêu?',
    weight_program_body_measurements_helper: 'Hãy dùng số đo gần đây.',
    weight_program_weight_related_conditions_title: 'Bác sĩ có từng nói bạn mắc bệnh nào dưới đây không?',
    weight_program_weight_related_conditions_option_hypertension: 'Huyết áp cao',
    weight_program_weight_related_conditions_option_high_cholesterol: 'Mỡ máu cao',
    weight_program_weight_related_conditions_option_type_2_diabetes: 'Tiểu đường loại 2',
    weight_program_weight_related_conditions_option_sleep_apnea: 'Ngưng thở khi ngủ',
    weight_program_weight_related_conditions_option_heart_disease: 'Bệnh tim',
    weight_program_reproductive_status_title: 'Có điều nào dưới đây đúng với bạn không?',
    weight_program_reproductive_status_option_pregnant_or_possible: 'Tôi đang mang thai hoặc có thể đang mang thai',
    weight_program_reproductive_status_option_planning_pregnancy: 'Tôi dự định có thai',
    weight_program_reproductive_status_option_breastfeeding: 'Tôi đang cho con bú',
    weight_program_reproductive_status_option_oral_contraceptives: 'Tôi đang uống thuốc tránh thai',
    weight_program_reproductive_status_option_prefer_to_discuss: 'Tôi muốn trao đổi trực tiếp về điều này',
    weight_program_mtc_men2_history_title: 'Bạn hoặc gia đình bạn đã từng bị MTC hoặc MEN2 chưa?',
    weight_program_mtc_men2_history_helper:
      "MTC là ung thư tuyến giáp thể tủy, một loại ung thư tuyến giáp hiếm gặp. MEN2 là một bệnh gây ra khối u. Chọn 'Tôi không chắc' nếu bạn cần trợ giúp.",
    weight_program_glp1_allergy_title:
      'Bạn đã từng bị dị ứng nặng với Foundayo hoặc thuốc giảm cân hay thuốc tiểu đường khác chưa?',
    weight_program_glp1_allergy_detail_label: 'Tên thuốc (không bắt buộc)',
    weight_program_gi_organ_history_title: 'Bạn đã từng gặp vấn đề sức khỏe nào dưới đây chưa?',
    weight_program_gi_organ_history_option_pancreatitis: 'Viêm tụy (tụy bị sưng)',
    weight_program_gi_organ_history_option_gallstones: 'Sỏi mật',
    weight_program_gi_organ_history_option_gastroparesis: 'Dạ dày tiêu hóa rất chậm',
    weight_program_gi_organ_history_option_recurrent_vomiting: 'Nôn nhiều lần',
    weight_program_gi_organ_history_option_kidney_disease: 'Bệnh thận',
    weight_program_gi_organ_history_option_severe_liver_disease: 'Bệnh gan nặng',
    weight_program_gi_organ_history_option_diabetic_retinopathy: 'Tổn thương mắt do tiểu đường',
    weight_program_eating_disorder_screen_title: 'Bạn đã từng bị rối loạn ăn uống hoặc gặp vấn đề nào dưới đây chưa?',
    weight_program_eating_disorder_screen_helper:
      'Chọn tất cả các mục phù hợp, kể cả trong quá khứ. Câu trả lời của bạn giúp chúng tôi lên kế hoạch hỗ trợ.',
    weight_program_eating_disorder_screen_option_anorexia_history:
      'Chán ăn tâm thần (nhịn ăn nghiêm trọng và sợ tăng cân)',
    weight_program_eating_disorder_screen_option_bulimia_history: 'Cuồng ăn (ăn vô độ rồi tìm cách loại bỏ)',
    weight_program_eating_disorder_screen_option_binge_or_other_history:
      'Rối loạn ăn uống vô độ hoặc rối loạn ăn uống khác',
    weight_program_eating_disorder_screen_option_restricting_from_fear: 'Tôi bỏ bữa vì sợ tăng cân',
    weight_program_eating_disorder_screen_option_purging_or_compensating:
      'Tôi nôn, dùng thuốc nhuận tràng hoặc thuốc lợi tiểu, hoặc tập thể dục để bù lại việc ăn',
    weight_program_eating_disorder_screen_option_loss_of_control_eating: 'Đôi khi tôi cảm thấy không thể ngừng ăn',
    weight_program_eating_disorder_screen_option_prefer_to_discuss: 'Tôi muốn trao đổi với bác sĩ của mình',
    weight_program_eating_disorder_screen_detail_label: 'Bạn có muốn bác sĩ biết điều gì không? (không bắt buộc)',
    weight_program_current_medications_title: 'Bạn có đang dùng thuốc hoặc thực phẩm bổ sung nào không?',
    weight_program_current_medications_helper:
      'Bao gồm insulin, thuốc tiểu đường hoặc thuốc giảm cân, sản phẩm mua trực tuyến, thực phẩm bổ sung và thuốc tránh thai.',
    weight_program_current_medications_option_will_list: 'Có',
    weight_program_current_medications_option_takes_none: 'Không',
    weight_program_current_medications_option_need_help: 'Tôi cần trợ giúp để lập danh sách',
    weight_program_current_medications_detail_label: 'Thuốc và thực phẩm bổ sung của bạn',
    weight_program_planned_anesthesia_title: 'Bạn có dự kiến phẫu thuật hoặc gây mê không?',
    weight_program_planned_anesthesia_helper: 'Gây mê là dùng thuốc để bạn ngủ trong khi làm thủ thuật.',
    weight_program_planned_anesthesia_date_label: 'Ngày, nếu bạn biết (không bắt buộc)',
    weight_program_support_needs_title: 'Bạn muốn được hỗ trợ điều gì trước khi bắt đầu?',
    weight_program_support_needs_option_medicine_questions: 'Hiểu về thuốc',
    weight_program_support_needs_option_side_effects: 'Tác dụng phụ',
    weight_program_support_needs_option_cost_or_access: 'Chi phí hoặc cách nhận thuốc',
    weight_program_support_needs_option_food_or_activity: 'Ăn uống hoặc vận động',
    weight_program_support_needs_option_other: 'Điều khác',
    weight_program_support_needs_option_ready_for_review: 'Tôi đã sẵn sàng để bác sĩ xem xét',
    weight_program_support_needs_detail_label: 'Bạn có muốn bác sĩ biết điều gì không? (không bắt buộc)',
    weight_program_decision_approved_title: 'Bạn đã được chấp thuận để bắt đầu',
    weight_program_decision_alternative_title: 'Bác sĩ đề xuất một phương pháp điều trị khác',
    weight_program_decision_not_appropriate_title: 'Foundayo hiện chưa phù hợp với bạn',
    weight_program_decision_status_approved: 'Đã chấp thuận',
    weight_program_decision_status_alternative: 'Phương pháp điều trị khác',
    weight_program_decision_status_not_appropriate: 'Không phù hợp',
    weight_program_decision_default_approved:
      'Bác sĩ đã xem câu trả lời của bạn và chấp thuận để bạn bắt đầu dùng Foundayo.',
    weight_program_decision_default_alternative:
      'Bác sĩ đã xem câu trả lời của bạn và đề xuất một phương pháp điều trị khác. Bác sĩ sẽ trao đổi với bạn về các bước tiếp theo.',
    weight_program_decision_default_not_appropriate:
      'Bác sĩ đã xem câu trả lời của bạn và quyết định rằng Foundayo hiện chưa phải là lựa chọn phù hợp với bạn.',
    weight_program_decision_reviewed_by_label: 'Người xem xét',
    weight_program_decision_message_from: 'Tin nhắn từ Bác sĩ {{doctor}}',
    weight_program_decision_message_from_dated: 'Tin nhắn từ Bác sĩ {{doctor}} ({{date}})',
    weight_program_decision_message_from_your_doctor: 'Tin nhắn từ bác sĩ của bạn',
    weight_program_decision_doctor_name: 'Bác sĩ {{doctor}}',
    weight_program_decision_start_again: 'Bắt đầu lại',
    weight_program_decision_status_awaiting_start: 'Chờ bắt đầu',
    weight_program_decision_medicine_label: 'Thuốc của bạn',
    weight_program_decision_prescription_label: 'Đơn thuốc',
    weight_program_decision_prescription_sent: 'Đã gửi đến nhà thuốc của bạn',
    weight_program_decision_prescription_preparing: 'Bác sĩ đang chuẩn bị',
    weight_program_date_save: 'Lưu',
    weight_program_date_save_failed: 'Chúng tôi không thể lưu ngày. Vui lòng thử lại.',
    weight_program_message_doctor: 'Nhắn tin cho bác sĩ của tôi',
    weight_program_plan_note_from: 'Kế hoạch hiện tại (Bác sĩ {{doctor}}, {{date}})',
    weight_program_weight_title: 'Cân nặng của bạn',
    weight_program_history_title: 'Lịch sử',
    weight_program_history_invited: 'Được mời tham gia chương trình',
    weight_program_history_consents: 'Đã chấp nhận các nội dung đồng ý',
    weight_program_history_form_sent: 'Đã gửi câu hỏi sức khỏe',
    weight_program_history_check_in_sent: 'Đã gửi biểu mẫu kiểm tra',
    weight_program_history_plan_updated_by: 'Kế hoạch được cập nhật bởi Bác sĩ {{doctor}}',
    weight_program_history_plan_updated: 'Đã cập nhật kế hoạch',
    weight_program_history_first_dose: 'Viên thuốc đầu tiên',
    weight_program_history_dose_start: 'Bắt đầu liều mới',
    weight_program_history_check_in_opened: 'Đã mở biểu mẫu kiểm tra',
    weight_program_history_check_in_missed: 'Đã bỏ lỡ biểu mẫu kiểm tra',
    weight_program_history_post_stop_check_in_sent: 'Đã gửi biểu mẫu kiểm tra sau khi ngừng thuốc',
    weight_program_history_post_stop_check_in_opened: 'Đã mở biểu mẫu kiểm tra sau khi ngừng thuốc',
    weight_program_history_post_stop_check_in_missed: 'Đã bỏ lỡ biểu mẫu kiểm tra sau khi ngừng thuốc',
    weight_program_decision_type_approve_to_start: 'Được chấp thuận để bắt đầu',
    weight_program_decision_type_alternative_treatment: 'Phương pháp điều trị khác',
    weight_program_decision_type_not_appropriate: 'Không phù hợp',
    weight_program_decision_type_continue: 'Tiếp tục',
    weight_program_decision_type_new_prescription: 'Đơn thuốc mới',
    weight_program_decision_type_hold: 'Tạm dừng',
    weight_program_decision_type_stop: 'Đã ngừng',
    weight_program_decision_type_continue_post_stop: 'Tiếp tục theo dõi',
    weight_program_decision_type_close: 'Đã đóng chương trình',
    weight_program_first_dose_title: 'Hãy cho chúng tôi biết khi bạn bắt đầu',
    weight_program_first_dose_body:
      'Các lần kiểm tra hằng tháng được lên lịch tính từ ngày bạn uống viên thuốc đầu tiên, không phải từ ngày kê đơn. Bạn có thể thay đổi ngày cho đến khi lần kiểm tra đầu tiên được mở.',
    weight_program_first_dose_label: 'Ngày bạn uống viên thuốc đầu tiên',
    weight_program_first_dose_change_label:
      'Ngày bạn uống viên thuốc đầu tiên (bạn có thể thay đổi cho đến khi lần kiểm tra đầu tiên được mở)',
    weight_program_dose_start_title: 'Bác sĩ đã cập nhật kế hoạch của bạn',
    weight_program_dose_start_decision_label: 'Quyết định',
    weight_program_dose_start_plan_label: 'Kế hoạch mới',
    weight_program_dose_start_form_title: 'Hãy cho chúng tôi biết khi bạn chuyển đổi',
    weight_program_dose_start_label: 'Ngày đầu tiên dùng {{medicine}}',
    weight_program_check_in_due_title: 'Đã đến lúc kiểm tra hằng tháng',
    weight_program_check_in_due_body:
      '10 câu hỏi ngắn về cân nặng, thuốc và cảm giác của bạn. Bác sĩ xem xét mọi lần kiểm tra, kể cả khi mọi thứ đều ổn.',
    weight_program_check_in_label: 'Kiểm tra',
    weight_program_check_in_cycle: 'Chu kỳ {{number}} · mở ngày {{date}}',
    weight_program_plan_dose_label: 'Liều hiện tại',
    weight_program_plan_dose_since: '{{medicine}} từ {{date}}',
    weight_program_check_in_last_weight_label: 'Cân nặng báo cáo gần nhất',
    weight_program_check_in_start: 'Bắt đầu kiểm tra',
    weight_program_check_in_help:
      'Nếu bạn có vấn đề mới trước lần kiểm tra tiếp theo, hãy liên hệ Tap qua Trò chuyện thay vì chờ biểu mẫu hằng tháng.',
    weight_program_check_in_submitted_title: 'Cảm ơn bạn. Thông tin cập nhật của bạn đã được gửi tới bác sĩ.',
    weight_program_check_in_submitted_body:
      'Một bác sĩ của Tap sẽ xem xét và cho bạn biết bước tiếp theo. Câu trả lời của bạn không làm thay đổi đơn thuốc.',
    weight_program_check_in_view_answers: 'Xem',
    weight_program_check_in_submitted_keep_taking:
      'Tiếp tục dùng thuốc theo đúng chỉ định cho đến khi bác sĩ có hướng dẫn khác. Nếu bạn có vấn đề mới trước lần kiểm tra tiếp theo, hãy liên hệ Tap qua Trò chuyện.',
    weight_program_treatment_title: 'Kế hoạch Foundayo của bạn',
    weight_program_on_hold_title: 'Bác sĩ đã tạm dừng kế hoạch',
    weight_program_stopped_title: 'Chương trình của bạn đã kết thúc',
    weight_program_status_on_treatment: 'Đang điều trị',
    weight_program_status_on_hold: 'Bác sĩ đã tạm dừng',
    weight_program_status_stopped: 'Đã ngừng',
    weight_program_status_post_stop: 'Đã ngừng thuốc · đang theo dõi',
    weight_program_post_stop_next_check_in: '{{date}} (lần kiểm tra {{number}}/2)',
    weight_program_post_stop_due_title: 'Đã đến lúc kiểm tra ngắn',
    weight_program_post_stop_due_body:
      '5 câu hỏi ngắn về cân nặng và cảm giác của bạn kể từ khi ngừng Foundayo. Bác sĩ xem xét mọi lần kiểm tra.',
    weight_program_post_stop_check_in_value: '{{number}}/2 · trả lời trước ngày {{date}}',
    weight_program_post_stop_stopped_label: 'Đã ngừng thuốc',
    weight_program_post_stop_help: 'Nếu bạn có vấn đề mới, hãy liên hệ Tap qua Trò chuyện thay vì chờ lần kiểm tra.',
    weight_program_post_stop_submitted_body: 'Một bác sĩ của Tap sẽ xem xét và cho bạn biết bước tiếp theo.',
    weight_program_post_stop_eyebrow: 'Kiểm tra sau khi ngừng thuốc',
    weight_program_post_stop_wellbeing_title: 'Bạn cảm thấy thế nào kể từ khi ngừng thuốc?',
    weight_program_post_stop_wellbeing_option_better: 'Tốt hơn',
    weight_program_post_stop_wellbeing_option_same: 'Gần như không đổi',
    weight_program_post_stop_wellbeing_option_worse: 'Tệ hơn',
    weight_program_post_stop_wellbeing_detail_label: 'Điều gì đã thay đổi? (không bắt buộc)',
    weight_program_post_stop_eating_title: 'Bạn có lo lắng gì về việc ăn uống hoặc cảm giác thèm ăn không?',
    weight_program_post_stop_eating_option_none: 'Không lo lắng gì',
    weight_program_post_stop_eating_option_concerned: 'Tôi lo lắng về việc ăn uống hoặc cảm giác thèm ăn',
    weight_program_post_stop_eating_option_prefer_to_discuss: 'Tôi muốn trao đổi về điều này',
    weight_program_post_stop_eating_detail_label: 'Bạn lo lắng điều gì? (không bắt buộc)',
    weight_program_post_stop_next_step_title: 'Bạn muốn làm gì tiếp theo?',
    weight_program_post_stop_next_step_option_fine: 'Tôi vẫn ổn, không cần gì thêm',
    weight_program_post_stop_next_step_option_talk_to_doctor: 'Tôi muốn trao đổi với bác sĩ',
    weight_program_post_stop_next_step_option_return_to_treatment: 'Tôi muốn trao đổi về việc dùng lại thuốc',
    weight_program_post_stop_next_step_detail_label: 'Bạn muốn bác sĩ biết điều gì? (không bắt buộc)',
    weight_program_next_check_in_paused: 'Đã tạm dừng, chưa lên lịch kiểm tra',
    weight_program_plan_dose_start_label: 'Dùng liều này từ',
    weight_program_plan_started_label: 'Bắt đầu chương trình',
    weight_program_plan_next_check_in_label: 'Lần kiểm tra tiếp theo',
    weight_program_monthly_eyebrow: 'Kiểm tra hằng tháng',
    weight_program_monthly_review_helper:
      'Bạn có thể quay lại và thay đổi bất kỳ điều gì trước khi gửi. Sau khi gửi, bác sĩ sẽ xem xét các câu trả lời này; mọi thay đổi thực hiện qua Trò chuyện.',
    weight_program_monthly_problem_weight_incomplete: 'Vui lòng điền cân nặng, đơn vị và ngày.',
    weight_program_monthly_weight_title: 'Hôm nay bạn nặng bao nhiêu?',
    weight_program_monthly_weight_helper: 'Hãy dùng số đo gần đây.',
    weight_program_monthly_weight_helper_previous:
      'Hãy dùng số đo gần đây. Lần trước bạn báo cáo {{weight}} vào ngày {{date}}.',
    weight_program_monthly_weight_label: 'Cân nặng hôm nay',
    weight_program_monthly_dose_match_title: 'Thông tin này có khớp với thuốc bạn đang dùng không?',
    weight_program_monthly_dose_match_helper: 'Hồ sơ của bạn ghi {{medicine}} mỗi ngày, bắt đầu từ {{date}}.',
    weight_program_monthly_dose_match_helper_no_date: 'Hồ sơ của bạn ghi {{medicine}} mỗi ngày.',
    weight_program_monthly_dose_match_option_same: 'Đúng, liều và ngày đều chính xác',
    weight_program_monthly_dose_match_option_different: 'Liều hoặc ngày bắt đầu khác',
    weight_program_monthly_dose_match_option_stopped: 'Tôi đã ngừng dùng',
    weight_program_monthly_dose_match_option_not_started: 'Tôi chưa bắt đầu',
    weight_program_monthly_dose_match_detail_label:
      'Liều thực tế, ngày bắt đầu hoặc ngày dùng liều cuối của bạn (nếu biết)',
    weight_program_monthly_missed_days_title: 'Tháng này bạn đã quên uống thuốc bao nhiêu ngày?',
    weight_program_monthly_missed_days_helper: 'Con số gần đúng cũng được nếu bạn không nhớ chính xác.',
    weight_program_monthly_missed_days_label: 'Tổng số ngày bỏ lỡ trong tháng này',
    weight_program_monthly_missed_days_in_a_row_label: 'Số ngày quên uống liên tiếp nhiều nhất',
    weight_program_monthly_missed_days_summary: 'Tổng cộng {{count}} ngày, {{inARow}} ngày liên tiếp',
    weight_program_monthly_appetite_title: 'Thuốc giúp bạn kiểm soát cơn đói và thèm ăn như thế nào?',
    weight_program_monthly_appetite_option_helping: 'Thuốc có giúp, và tôi vẫn ăn được các bữa bình thường',
    weight_program_monthly_appetite_option_still_hungry: 'Cơn đói hoặc thèm ăn vẫn khó kiểm soát',
    weight_program_monthly_appetite_option_little_appetite: 'Tôi chán ăn đến mức khó ăn được',
    weight_program_monthly_appetite_option_no_change: 'Tôi không nhận thấy thay đổi nào',
    weight_program_monthly_side_effects_title: 'Tác dụng phụ làm bạn khó chịu đến mức nào?',
    weight_program_monthly_side_effects_helper:
      'Ví dụ: buồn nôn, nôn, tiêu chảy, táo bón hoặc các triệu chứng mới khác.',
    weight_program_monthly_side_effects_option_none: 'Hoàn toàn không',
    weight_program_monthly_side_effects_option_mild: 'Nhẹ, và tôi vẫn làm được các hoạt động thường ngày',
    weight_program_monthly_side_effects_option_interfere: 'Ảnh hưởng đến việc ăn uống hoặc sinh hoạt hằng ngày của tôi',
    weight_program_monthly_side_effects_option_severe: 'Rất nặng',
    weight_program_monthly_side_effects_detail_label: 'Tác dụng phụ nào, và bao lâu một lần? (nếu biết)',
    weight_program_monthly_eating_and_fluids_title: 'Việc ăn, uống và sinh hoạt hằng ngày của bạn thế nào?',
    weight_program_monthly_eating_and_fluids_option_usual: 'Tôi ăn, uống và làm được các hoạt động thường ngày',
    weight_program_monthly_eating_and_fluids_option_hard_to_eat: 'Tôi khó ăn các bữa bình thường',
    weight_program_monthly_eating_and_fluids_option_hard_to_drink: 'Tôi khó uống đủ nước',
    weight_program_monthly_eating_and_fluids_option_cannot_keep_fluids: 'Tôi không giữ được nước uống (bị nôn ra)',
    weight_program_monthly_eating_and_fluids_option_less_urine: 'Tôi đi tiểu ít hơn nhiều',
    weight_program_monthly_eating_and_fluids_option_weaker: 'Tôi thấy yếu hơn hoặc việc hằng ngày khó khăn hơn',
    weight_program_monthly_warning_signs_title: 'Bạn có gặp dấu hiệu cảnh báo nào dưới đây không?',
    weight_program_monthly_warning_signs_helper:
      'Chọn tất cả các mục phù hợp. Nếu là trường hợp khẩn cấp, hãy tìm trợ giúp ngay; đừng chờ hoàn thành biểu mẫu.',
    weight_program_monthly_warning_signs_option_persistent_belly_pain: 'Đau bụng dữ dội không hết',
    weight_program_monthly_warning_signs_option_yellow_skin_or_eyes: 'Vàng da hoặc vàng mắt',
    weight_program_monthly_warning_signs_option_vision_trouble: 'Mới gặp vấn đề về thị lực',
    weight_program_monthly_warning_signs_option_neck_lump_or_hoarse: 'Có khối u ở cổ hoặc khàn giọng kéo dài',
    weight_program_monthly_warning_signs_option_face_or_tongue_swelling: 'Sưng mặt hoặc lưỡi',
    weight_program_monthly_warning_signs_option_trouble_breathing: 'Khó thở',
    weight_program_monthly_warning_signs_option_low_blood_sugar:
      'Hạ đường huyết, run, đổ mồ hôi, choáng váng hoặc lú lẫn',
    weight_program_monthly_warning_signs_detail_label:
      'Việc này xảy ra khi nào và bạn nhận thấy điều gì? (không bắt buộc)',
    weight_program_monthly_changes_title: 'Có điều nào dưới đây thay đổi kể từ lần kiểm tra trước không?',
    weight_program_monthly_changes_option_medicines: 'Thuốc hoặc thực phẩm bổ sung mới, đã ngừng hoặc đã thay đổi',
    weight_program_monthly_changes_option_health: 'Vấn đề sức khỏe mới hoặc điều khác',
    weight_program_monthly_changes_option_pregnant: 'Tôi đang mang thai hoặc có thể đang mang thai',
    weight_program_monthly_changes_option_planning_pregnancy: 'Tôi dự định có thai',
    weight_program_monthly_changes_option_breastfeeding: 'Tôi đang cho con bú',
    weight_program_monthly_changes_option_birth_control_pills: 'Thuốc tránh thai dạng uống',
    weight_program_monthly_changes_option_periods_changed:
      'Kinh nguyệt của tôi ngừng hoặc thay đổi mà tôi không rõ lý do',
    weight_program_monthly_changes_option_procedure_planned: 'Tôi dự kiến phẫu thuật hoặc gây mê',
    weight_program_monthly_changes_option_none: 'Không có thay đổi',
    weight_program_monthly_changes_detail_label: 'Hãy cho bác sĩ biết thêm một chút (không bắt buộc)',
    weight_program_monthly_changes_reported_title: 'Các loại thuốc bạn đã liệt kê trước đây',
    weight_program_monthly_changes_reported_helper:
      'Đây là những gì bạn đã cho chúng tôi biết lần trước. Nếu có gì thay đổi, hãy chọn lựa chọn đầu tiên bên dưới và cập nhật danh sách.',
    weight_program_monthly_changes_medications_label: 'Thuốc và thực phẩm bổ sung bạn đang dùng hiện nay (bắt buộc)',
    weight_program_monthly_changes_medications_helper:
      'Chúng tôi đã điền sẵn danh sách lần trước của bạn. Hãy thêm, bớt hoặc sửa những gì đã khác đi.',
    weight_program_monthly_changes_medications_summary: 'Thuốc hiện nay: {{list}}',
    weight_program_monthly_eating_concerns_title: 'Tháng này bạn có gặp điều nào dưới đây không?',
    weight_program_monthly_eating_concerns_helper:
      'Chọn tất cả các mục phù hợp. Chúng tôi hỏi tất cả mọi người để hỗ trợ điều trị an toàn.',
    weight_program_monthly_eating_concerns_option_restricting_from_fear: 'Tôi bỏ bữa vì sợ tăng cân',
    weight_program_monthly_eating_concerns_option_purging_or_compensating:
      'Tôi nôn, dùng thuốc nhuận tràng hoặc thuốc lợi tiểu, hoặc tập thể dục để bù lại việc ăn',
    weight_program_monthly_eating_concerns_option_loss_of_control_eating: 'Đôi khi tôi cảm thấy không thể ngừng ăn',
    weight_program_monthly_eating_concerns_option_worries_interfere:
      'Lo lắng về ăn uống hoặc cân nặng ảnh hưởng đến cuộc sống hằng ngày của tôi',
    weight_program_monthly_eating_concerns_option_dose_change_upsetting:
      'Việc giảm liều hoặc ngừng thuốc khiến tôi rất bất an',
    weight_program_monthly_eating_concerns_option_took_extra: 'Tôi đã dùng thuốc nhiều hơn liều được kê',
    weight_program_monthly_eating_concerns_option_other_source: 'Tôi đã dùng thuốc giảm cân từ nguồn khác',
    weight_program_monthly_eating_concerns_option_prefer_to_discuss: 'Tôi muốn trao đổi với bác sĩ của mình',
    weight_program_monthly_eating_concerns_detail_label: 'Bạn có muốn chia sẻ điều gì không? (không bắt buộc)',
    weight_program_monthly_plan_preference_title: 'Bạn muốn trao đổi điều gì về kế hoạch của mình?',
    weight_program_monthly_plan_preference_helper:
      'Chọn tất cả các mục phù hợp. Câu trả lời của bạn không làm thay đổi liều thuốc.',
    weight_program_monthly_plan_preference_option_continue: 'Giữ kế hoạch hiện tại',
    weight_program_monthly_plan_preference_option_increase: 'Thêm hỗ trợ để đạt mục tiêu hoặc tăng liều',
    weight_program_monthly_plan_preference_option_decrease: 'Giảm liều hoặc được hỗ trợ về tác dụng phụ',
    weight_program_monthly_plan_preference_option_maintain:
      'Tôi gần đạt hoặc đã ở trong khoảng mục tiêu và muốn duy trì',
    weight_program_monthly_plan_preference_option_losing_too_much: 'Tôi đang giảm cân nhiều hơn mong muốn',
    weight_program_monthly_plan_preference_option_need_goal: 'Tôi cần trợ giúp đặt mục tiêu',
    weight_program_monthly_plan_preference_option_stop: 'Ngừng thuốc hoặc chuyển nơi chăm sóc',
    weight_program_monthly_plan_preference_option_cost_or_access: 'Chi phí hoặc cách nhận thuốc',
    weight_program_monthly_plan_preference_option_question: 'Câu hỏi khác',
    weight_program_monthly_plan_preference_detail_label: 'Bạn muốn bác sĩ biết điều gì? (không bắt buộc)',

    // Phone-first auth
    phone_auth_error_generic: 'Đã xảy ra lỗi. Vui lòng thử lại.',
    google_sign_in_error: 'Không thể kết nối với dịch vụ xác thực của Google. Vui lòng thử lại.',
    profile_updated_success: 'Đã cập nhật hồ sơ thành công!',
    phone_auth_error_rate_limited: 'Quá nhiều lần thử, vui lòng thử lại sau vài phút.',
    phone_auth_error_session_expired: 'Phiên đăng ký của bạn đã hết hạn. Vui lòng bắt đầu lại.',
    phone_auth_error_code_invalid: 'Mã này không đúng. Vui lòng kiểm tra và thử lại.',
    phone_auth_error_code_expired: 'Mã này đã hết hạn. Vui lòng yêu cầu mã mới.',
    phone_auth_error_code_send_failed: 'Chúng tôi không thể gửi mã. Vui lòng thử lại.',
    phone_auth_error_patient_required: 'Tài khoản này chưa có hồ sơ bệnh nhân.',
    phone_auth_error_email_not_verified: 'Vui lòng xác nhận email của bạn trước.',
    phone_auth_error_patient_not_allowed: 'Hồ sơ này không khả dụng cho số điện thoại này.',
    phone_auth_error_already_claimed: 'Hồ sơ này đã được liên kết với một tài khoản. Vui lòng đăng nhập.',
    phone_auth_error_already_registered: 'Bạn đã đăng ký rồi. Vui lòng đăng nhập.',
    phone_auth_error_already_confirmed: 'Số điện thoại này đã được xác nhận.',
    phone_auth_error_dob_required: 'Vui lòng nhập ngày sinh của bạn.',
    phone_auth_error_dob_mismatch:
      'Ngày sinh bạn nhập không khớp với hồ sơ của chúng tôi. Vui lòng nhắn tin cho chúng tôi từ điện thoại này và nhà cung cấp dịch vụ sẽ kiểm tra thông tin của bạn.',
    phone_auth_error_dob_attempts_exceeded:
      'Quá nhiều lần nhập sai. Hãy đợi 20 phút rồi thử lại, hoặc nhắn tin cho chúng tôi từ điện thoại này và nhà cung cấp dịch vụ sẽ kiểm tra thông tin của bạn.',
    phone_auth_error_must_be_adult: 'Bạn phải từ 18 tuổi trở lên để tạo tài khoản.',
    phone_auth_error_hipaa_required: 'Vui lòng chấp nhận thỏa thuận về quyền riêng tư để tiếp tục.',
    phone_auth_error_terms_required: 'Vui lòng chấp nhận Điều khoản sử dụng và Chính sách quyền riêng tư để tiếp tục.',
    phone_auth_error_same_number: 'Đây là số của chính bạn. Hãy nhập số điện thoại riêng của người lớn kia.',
    phone_auth_error_phone_required: 'Vui lòng nhập số điện thoại.',
    phone_auth_error_number_has_account: 'Số này đã thuộc về một tài khoản. Vui lòng dùng số khác.',
    phone_auth_error_register_by_phone:
      'Không có tài khoản cho email Google này. Hãy đăng ký bằng số điện thoại của bạn trước.',
    phone_auth_invalid_phone: 'Nhập số điện thoại hợp lệ của Hoa Kỳ.',
    phone_auth_code_sent_to: 'Nhập mã gồm 6 chữ số đã gửi đến {{target}}.',
    phone_auth_resend: 'Gửi mã mới',
    phone_auth_resend_wait: 'Gửi mã mới ({{seconds}} giây)',
    phone_auth_change_number: 'Dùng số khác',
    phone_auth_change_email: 'Dùng email khác',
    phone_auth_verify_title: 'Xác minh số điện thoại của bạn',
    phone_auth_login_title: 'Đăng nhập',
    phone_auth_login_subtitle: 'Nhập số điện thoại của bạn. Chúng tôi sẽ gửi mã dùng một lần qua SMS.',
    phone_auth_use_email_instead: 'Đăng nhập bằng email của bạn',
    phone_auth_use_phone_instead: 'Đăng nhập bằng số điện thoại của bạn',
    phone_auth_email_login_title: 'Đăng nhập bằng email của bạn',
    phone_auth_email_login_subtitle: 'Chúng tôi sẽ gửi mã dùng một lần đến địa chỉ email của bạn.',
    phone_auth_check_email: 'Kiểm tra email của bạn',
    phone_auth_email_code_hint:
      'Nếu email này được liên kết với một tài khoản, chúng tôi đã gửi một mã. Mã có hiệu lực trong 10 phút. Nhập mã bên dưới.',
    phone_auth_no_account_continue_phone: 'Chưa có tài khoản? Tiếp tục bằng số điện thoại của bạn',
    phone_auth_no_account_title: 'Chưa có tài khoản',
    phone_auth_no_account_text:
      'Số điện thoại của bạn đã được xác minh nhưng chưa có tài khoản cho số này. Bạn có thể tạo hồ sơ bệnh nhân ngay bây giờ. Chỉ mất khoảng một phút.',
    phone_auth_create_profile: 'Tạo hồ sơ của tôi',
    phone_auth_create_account: 'Tạo tài khoản của bạn',
    phone_auth_register_title: 'Tạo tài khoản của bạn',
    phone_auth_register_subtitle:
      'Nhập số điện thoại của bạn. Chúng tôi sẽ gửi mã dùng một lần qua SMS. Không cần mật khẩu.',
    phone_auth_sign_in: 'Đăng nhập',
    phone_auth_account_exists_title: 'Bạn đã có tài khoản',
    phone_auth_account_exists_text:
      'Số này đã được liên kết với một tài khoản hiện có, vì vậy chúng tôi đã đăng nhập cho bạn.',
    phone_auth_choose_title: 'Hồ sơ nào là của bạn?',
    phone_auth_choose_subtitle:
      'Nhiều người dùng số này. Hãy chọn hồ sơ của bạn. Chúng tôi chỉ hiển thị tên viết tắt và năm sinh.',
    phone_auth_choose_none: 'Tôi không có trong danh sách này, hãy thêm tôi',
    phone_auth_choose_hint:
      'Không nhận ra ai đó trong danh sách này? Vui lòng nhắn tin cho chúng tôi từ điện thoại này để chúng tôi kiểm tra số.',
    phone_auth_found_title: 'Chúng tôi đã tìm thấy hồ sơ bệnh nhân của bạn',
    phone_auth_found_subtitle:
      'Lịch sử chăm sóc của bạn sẽ được kết nối với tài khoản này. Xác nhận thông tin của bạn để tiếp tục.',
    phone_auth_profile_title: 'Tạo hồ sơ bệnh nhân của bạn',
    phone_auth_profile_subtitle: 'Chúng tôi không tìm thấy hồ sơ bệnh nhân hiện có cho số điện thoại này.',
    phone_auth_add_email_title: 'Thêm email của bạn',
    phone_auth_email_hint:
      'Chúng tôi có một email trong hồ sơ kết thúc bằng {{hint}}. Hãy nhập email đó để nhận mã, hoặc dùng email khác.',
    phone_auth_add_email_subtitle: 'Email là cách đăng nhập dự phòng nếu bạn mất quyền truy cập vào số điện thoại.',
    phone_auth_heard_title: 'Một câu hỏi cuối cùng',
    phone_auth_finish: 'Hoàn tất',
    phone_auth_skip: 'Bỏ qua',
    phone_auth_profile_ready: 'Hồ sơ của bạn đã sẵn sàng',
    phone_auth_invitation_invalid: 'Liên kết lời mời này không hợp lệ.',
    phone_auth_invitation_invalid_title: 'Liên kết lời mời này không còn hợp lệ',
    phone_auth_invitation_invalid_text:
      'Liên kết đã được sử dụng hoặc đã hết hạn. Nếu bạn đã thiết lập tài khoản, hãy đăng nhập bằng số điện thoại của bạn. Nếu chưa, hãy yêu cầu nhà cung cấp dịch vụ gửi lời mời mới.',
    phone_auth_invitation_title: 'Xác nhận số điện thoại của bạn',
    phone_auth_invitation_hint: 'Chúng tôi sẽ gửi mã đến số điện thoại trong hồ sơ của bạn, kết thúc bằng {{hint}}.',
    phone_auth_invitation_another_number: 'Đây không còn là số của tôi',
    phone_auth_invitation_other_number: 'Nhập số điện thoại bạn muốn dùng. Chúng tôi sẽ gửi mã dùng một lần qua SMS.',
    phone_auth_invitation_no_number:
      'Hồ sơ của bạn chưa có số điện thoại. Hãy nhập số của bạn và chúng tôi sẽ gửi mã dùng một lần qua SMS.',
    phone_auth_invitation_use_record_number: 'Dùng số trong hồ sơ của tôi',
    phone_auth_claim_invalid_link: 'Liên kết này không hợp lệ.',
    phone_auth_claim_hello: 'Xin chào, {{name}}',
    phone_auth_claim_subtitle: 'Xác nhận số điện thoại kết thúc bằng {{hint}}. Số này sẽ chỉ được dùng cho bạn.',
    phone_auth_claim_confirm: 'Xác nhận',
    phone_auth_claim_done_title: 'Cảm ơn, số điện thoại của bạn đã được xác nhận',
    phone_auth_claim_done_text: 'Bây giờ bạn có thể đăng nhập vào Cổng thông tin bệnh nhân bằng số này.',
    phone_auth_claim_already_used: 'Liên kết này đã được sử dụng.',
    phone_auth_add_phone_title: 'Thêm số điện thoại của bạn',
    phone_auth_add_phone_text: 'Nhập số điện thoại của bạn. Chúng tôi sẽ gửi mã dùng một lần qua SMS.',
    phone_auth_add_phone_banner:
      'Tài khoản của bạn chưa có số điện thoại đã xác minh. Hãy thêm số để đăng nhập nhanh hơn lần sau và để chúng tôi có thể nhắn tin cho bạn về việc chăm sóc.',
    phone_auth_add_phone_cta: 'Thêm số',
    phone_auth_add_phone_done: 'Số điện thoại của bạn đã được xác minh',
    phone_auth_shared_title: 'Những người lớn khác trong hộ gia đình của bạn dùng chung số này',
    phone_auth_shared_text:
      'Mỗi người lớn cần có số riêng để chúng tôi giữ kín việc chăm sóc của họ. Nhập số điện thoại của họ và chúng tôi sẽ nhắn tin cho họ một liên kết để xác nhận.',
    phone_auth_shared_cta: 'Nhập số của họ',
    phone_auth_became_adult: '{{name}} nay đã là người lớn',
    phone_auth_their_number: 'Số điện thoại của họ',
    phone_auth_send_link: 'Gửi liên kết',
    phone_auth_has_login_note: 'Hồ sơ này đã có tài khoản. Xác nhận ngày sinh của bạn để đăng nhập.',
    phone_auth_link_sent: 'Đã gửi liên kết',
    // Google connect
    phone_auth_error_google_state_invalid: 'Xác nhận Google này đã hết hạn hoặc đã được sử dụng. Vui lòng thử lại.',
    phone_auth_error_google_state_forbidden:
      'Xác nhận Google này không thuộc phiên hiện tại của bạn. Vui lòng thử lại.',
    phone_auth_error_google_email_unverified: 'Google chưa xác minh địa chỉ email này. Hãy dùng tài khoản Google khác.',
    phone_auth_error_google_account_in_use: 'Tài khoản Google này đã được liên kết với một tài khoản đăng nhập khác.',
    phone_auth_google_confirm: 'Xác nhận bằng Google',
    google_cancelled: 'Đã hủy đăng nhập bằng Google',
    google_session_missing: 'Hãy đăng nhập và thử lại.',
    google_connected_success: 'Đã liên kết tài khoản Google',
    google_email_changed_success: 'Email đăng nhập của bạn đã được cập nhật',
    signin_methods_load_error: 'Không thể tải các phương thức đăng nhập của bạn. Vui lòng thử lại sau.',
    signin_methods_title: 'Phương thức đăng nhập',
    signin_methods_phone: 'Số điện thoại',
    signin_methods_email: 'Email',
    signin_methods_google: 'Google',
    signin_methods_verified: 'Đã xác minh',
    signin_methods_not_confirmed: 'Chưa xác nhận',
    signin_methods_not_verified: 'Chưa xác minh',
    signin_methods_connected: 'Đã liên kết',
    signin_methods_not_connected: 'Chưa liên kết',
    signin_methods_connected_since: 'từ {{date}}',
    signin_methods_google_default: 'Dùng được với email của tài khoản bạn',
    signin_methods_use_other_google: 'Dùng tài khoản Google khác',
    signin_methods_connect_google: 'Liên kết Google',
    signin_methods_not_set: 'Chưa đặt',
    google_email_change_title: 'Đổi email đăng nhập',
    google_email_change_text: 'Email đăng nhập của bạn sẽ đổi từ {{old}} sang {{new}}. Tiếp tục?',
  },
}
